webpackJsonp([216210090109534],{

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	var QueryHandler = __webpack_require__(58);
	var each = __webpack_require__(27).each;
	
	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);
	
	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}
	
	MediaQuery.prototype = {
	
	    constuctor : MediaQuery,
	
	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);
	
	        this.matches() && qh.on();
	    },
	
	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },
	
	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },
	
	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },
	
	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';
	
	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};
	
	module.exports = MediaQuery;


/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	var MediaQuery = __webpack_require__(56);
	var Util = __webpack_require__(27);
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;
	
	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }
	
	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}
	
	MediaQueryDispatch.prototype = {
	
	    constructor : MediaQueryDispatch,
	
	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;
	
	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }
	
	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });
	
	        return this;
	    },
	
	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];
	
	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }
	
	        return this;
	    }
	};
	
	module.exports = MediaQueryDispatch;


/***/ }),

/***/ 58:
/***/ (function(module, exports) {

	/**
	 * Delegate to handle a media query being matched and unmatched.
	 *
	 * @param {object} options
	 * @param {function} options.match callback for when the media query is matched
	 * @param {function} [options.unmatch] callback for when the media query is unmatched
	 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	 * @constructor
	 */
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}
	
	QueryHandler.prototype = {
	
	    constructor : QueryHandler,
	
	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },
	
	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },
	
	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },
	
	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },
	
	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }
	
	};
	
	module.exports = QueryHandler;


/***/ }),

/***/ 27:
/***/ (function(module, exports) {

	/**
	 * Helper function for iterating over a collection
	 *
	 * @param collection
	 * @param fn
	 */
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;
	
	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}
	
	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}
	
	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}
	
	module.exports = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};


/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

	var MediaQueryDispatch = __webpack_require__(57);
	module.exports = new MediaQueryDispatch();


/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

	var camel2hyphen = __webpack_require__(73);
	
	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and '
	    }
	  });
	  return mq;
	};
	
	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', '
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ }),

/***/ 63:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.NextArrow = exports.PrevArrow = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(15);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _innerSliderUtils = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrevArrow = exports.PrevArrow = function (_React$PureComponent) {
	  _inherits(PrevArrow, _React$PureComponent);
	
	  function PrevArrow() {
	    _classCallCheck(this, PrevArrow);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  PrevArrow.prototype.render = function render() {
	    var prevClasses = { "slick-arrow": true, "slick-prev": true };
	    var prevHandler = this.clickHandler.bind(this, { message: "previous" });
	
	    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	      prevClasses["slick-disabled"] = true;
	      prevHandler = null;
	    }
	
	    var prevArrowProps = {
	      key: "0",
	      "data-role": "none",
	      className: (0, _classnames2.default)(prevClasses),
	      style: { display: "block" },
	      onClick: prevHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var prevArrow = void 0;
	
	    if (this.props.prevArrow) {
	      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
	    } else {
	      prevArrow = _react2.default.createElement(
	        "button",
	        _extends({ key: "0", type: "button" }, prevArrowProps),
	        " ",
	        "Previous"
	      );
	    }
	
	    return prevArrow;
	  };
	
	  return PrevArrow;
	}(_react2.default.PureComponent);
	
	var NextArrow = exports.NextArrow = function (_React$PureComponent2) {
	  _inherits(NextArrow, _React$PureComponent2);
	
	  function NextArrow() {
	    _classCallCheck(this, NextArrow);
	
	    return _possibleConstructorReturn(this, _React$PureComponent2.apply(this, arguments));
	  }
	
	  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  NextArrow.prototype.render = function render() {
	    var nextClasses = { "slick-arrow": true, "slick-next": true };
	    var nextHandler = this.clickHandler.bind(this, { message: "next" });
	
	    if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
	      nextClasses["slick-disabled"] = true;
	      nextHandler = null;
	    }
	
	    var nextArrowProps = {
	      key: "1",
	      "data-role": "none",
	      className: (0, _classnames2.default)(nextClasses),
	      style: { display: "block" },
	      onClick: nextHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var nextArrow = void 0;
	
	    if (this.props.nextArrow) {
	      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
	    } else {
	      nextArrow = _react2.default.createElement(
	        "button",
	        _extends({ key: "1", type: "button" }, nextArrowProps),
	        " ",
	        "Next"
	      );
	    }
	
	    return nextArrow;
	  };
	
	  return NextArrow;
	}(_react2.default.PureComponent);

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultProps = {
	  accessibility: true,
	  adaptiveHeight: false,
	  afterChange: null,
	  appendDots: function appendDots(dots) {
	    return _react2.default.createElement(
	      "ul",
	      { style: { display: "block" } },
	      dots
	    );
	  },
	  arrows: true,
	  autoplay: false,
	  autoplaySpeed: 3000,
	  beforeChange: null,
	  centerMode: false,
	  centerPadding: "50px",
	  className: "",
	  cssEase: "ease",
	  customPaging: function customPaging(i) {
	    return _react2.default.createElement(
	      "button",
	      null,
	      i + 1
	    );
	  },
	  dots: false,
	  dotsClass: "slick-dots",
	  draggable: true,
	  easing: "linear",
	  edgeFriction: 0.35,
	  fade: false,
	  focusOnSelect: false,
	  infinite: true,
	  initialSlide: 0,
	  lazyLoad: null,
	  nextArrow: null,
	  onEdge: null,
	  onInit: null,
	  onLazyLoadError: null,
	  onReInit: null,
	  pauseOnDotsHover: false,
	  pauseOnFocus: false,
	  pauseOnHover: true,
	  prevArrow: null,
	  responsive: null,
	  rows: 1,
	  rtl: false,
	  slide: "div",
	  slidesPerRow: 1,
	  slidesToScroll: 1,
	  slidesToShow: 1,
	  speed: 500,
	  swipe: true,
	  swipeEvent: null,
	  swipeToSlide: false,
	  touchMove: true,
	  touchThreshold: 5,
	  useCSS: true,
	  useTransform: true,
	  variableWidth: false,
	  vertical: false,
	  waitForAnimate: true
	};
	
	exports.default = defaultProps;

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Dots = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(15);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDotCount = function getDotCount(spec) {
	  var dots;
	
	  if (spec.infinite) {
	    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  } else {
	    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
	  }
	
	  return dots;
	};
	
	var Dots = exports.Dots = function (_React$PureComponent) {
	  _inherits(Dots, _React$PureComponent);
	
	  function Dots() {
	    _classCallCheck(this, Dots);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  Dots.prototype.clickHandler = function clickHandler(options, e) {
	    // In Autoplay the focus stays on clicked button even after transition
	    // to next slide. That only goes away by click somewhere outside
	    e.preventDefault();
	    this.props.clickHandler(options);
	  };
	
	  Dots.prototype.render = function render() {
	    var _this2 = this;
	
	    var dotCount = getDotCount({
	      slideCount: this.props.slideCount,
	      slidesToScroll: this.props.slidesToScroll,
	      slidesToShow: this.props.slidesToShow,
	      infinite: this.props.infinite
	    });
	
	    // Apply join & split to Array to pre-fill it for IE8
	    //
	    // Credit: http://stackoverflow.com/a/13735425/1849458
	    var _props = this.props,
	        onMouseEnter = _props.onMouseEnter,
	        onMouseOver = _props.onMouseOver,
	        onMouseLeave = _props.onMouseLeave;
	
	    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
	    var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
	      var leftBound = i * _this2.props.slidesToScroll;
	      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
	      var className = (0, _classnames2.default)({
	        "slick-active": _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
	      });
	
	      var dotOptions = {
	        message: "dots",
	        index: i,
	        slidesToScroll: _this2.props.slidesToScroll,
	        currentSlide: _this2.props.currentSlide
	      };
	
	      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
	      return _react2.default.createElement(
	        "li",
	        { key: i, className: className },
	        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
	      );
	    });
	
	    return _react2.default.cloneElement(this.props.appendDots(dots), _extends({
	      className: this.props.dotsClass
	    }, mouseEvents));
	  };
	
	  return Dots;
	}(_react2.default.PureComponent);

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _slider = __webpack_require__(70);
	
	var _slider2 = _interopRequireDefault(_slider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _slider2.default;

/***/ }),

/***/ 68:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var initialState = {
	  animating: false,
	  autoplaying: null,
	  currentDirection: 0,
	  currentLeft: null,
	  currentSlide: 0,
	  direction: 1,
	  dragging: false,
	  edgeDragged: false,
	  initialized: false,
	  lazyLoadedList: [],
	  listHeight: null,
	  listWidth: null,
	  scrolling: false,
	  slideCount: null,
	  slideHeight: null,
	  slideWidth: null,
	  swipeLeft: null,
	  swiped: false, // used by swipeEvent. differentites between touch and swipe.
	  swiping: false,
	  touchObject: { startX: 0, startY: 0, curX: 0, curY: 0 },
	  trackStyle: {},
	  trackWidth: 0
	};
	
	exports.default = initialState;

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.InnerSlider = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(29);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _initialState = __webpack_require__(68);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _lodash = __webpack_require__(63);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(15);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _innerSliderUtils = __webpack_require__(13);
	
	var _track = __webpack_require__(71);
	
	var _dots = __webpack_require__(66);
	
	var _arrows = __webpack_require__(64);
	
	var _resizeObserverPolyfill = __webpack_require__(72);
	
	var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InnerSlider = exports.InnerSlider = function (_React$Component) {
	  _inherits(InnerSlider, _React$Component);
	
	  function InnerSlider(props) {
	    _classCallCheck(this, InnerSlider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.listRefHandler = function (ref) {
	      return _this.list = ref;
	    };
	
	    _this.trackRefHandler = function (ref) {
	      return _this.track = ref;
	    };
	
	    _this.adaptHeight = function () {
	      if (_this.props.adaptiveHeight && _this.list) {
	        var elem = _this.list.querySelector("[data-index=\"" + _this.state.currentSlide + "\"]");
	        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
	      }
	    };
	
	    _this.componentWillMount = function () {
	      _this.ssrInit();
	      _this.props.onInit && _this.props.onInit();
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      }
	    };
	
	    _this.componentDidMount = function () {
	      var spec = _extends({ listRef: _this.list, trackRef: _this.track }, _this.props);
	      _this.updateState(spec, true, function () {
	        _this.adaptHeight();
	        _this.props.autoplay && _this.autoPlay("update");
	      });
	      if (_this.props.lazyLoad === "progressive") {
	        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
	      }
	      _this.ro = new _resizeObserverPolyfill2.default(function () {
	        if (_this.state.animating) {
	          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
	          _this.callbackTimers.push(setTimeout(function () {
	            return _this.onWindowResized();
	          }, _this.props.speed));
	        } else {
	          _this.onWindowResized();
	        }
	      });
	      _this.ro.observe(_this.list);
	      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
	        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
	        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
	      });
	      // To support server-side rendering
	      if (!window) {
	        return;
	      }
	      if (window.addEventListener) {
	        window.addEventListener("resize", _this.onWindowResized);
	      } else {
	        window.attachEvent("onresize", _this.onWindowResized);
	      }
	    };
	
	    _this.componentWillUnmount = function () {
	      if (_this.animationEndCallback) {
	        clearTimeout(_this.animationEndCallback);
	      }
	      if (_this.lazyLoadTimer) {
	        clearInterval(_this.lazyLoadTimer);
	      }
	      if (_this.callbackTimers.length) {
	        _this.callbackTimers.forEach(function (timer) {
	          return clearTimeout(timer);
	        });
	        _this.callbackTimers = [];
	      }
	      if (window.addEventListener) {
	        window.removeEventListener("resize", _this.onWindowResized);
	      } else {
	        window.detachEvent("onresize", _this.onWindowResized);
	      }
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	    };
	
	    _this.componentWillReceiveProps = function (nextProps) {
	      var spec = _extends({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, nextProps, _this.state);
	      var setTrackStyle = false;
	      for (var _iterator = Object.keys(_this.props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	        var _ref;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }
	
	        var key = _ref;
	
	        if (!nextProps.hasOwnProperty(key)) {
	          setTrackStyle = true;
	          break;
	        }
	        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
	          continue;
	        }
	        if (nextProps[key] !== _this.props[key]) {
	          setTrackStyle = true;
	          break;
	        }
	      }
	      _this.updateState(spec, setTrackStyle, function () {
	        if (_this.state.currentSlide >= _react2.default.Children.count(nextProps.children)) {
	          _this.changeSlide({
	            message: "index",
	            index: _react2.default.Children.count(nextProps.children) - nextProps.slidesToShow,
	            currentSlide: _this.state.currentSlide
	          });
	        }
	        if (nextProps.autoplay) {
	          _this.autoPlay("update");
	        } else {
	          _this.pause("paused");
	        }
	      });
	    };
	
	    _this.componentDidUpdate = function () {
	      _this.checkImagesLoad();
	      _this.props.onReInit && _this.props.onReInit();
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      }
	      // if (this.props.onLazyLoad) {
	      //   this.props.onLazyLoad([leftMostSlide])
	      // }
	      _this.adaptHeight();
	    };
	
	    _this.onWindowResized = function (setTrackStyle) {
	      if (_this.debouncedResize) _this.debouncedResize.cancel();
	      _this.debouncedResize = (0, _lodash2.default)(function () {
	        return _this.resizeWindow(setTrackStyle);
	      }, 50);
	      _this.debouncedResize();
	    };
	
	    _this.resizeWindow = function () {
	      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      if (!_reactDom2.default.findDOMNode(_this.track)) return;
	      var spec = _extends({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props, _this.state);
	      _this.updateState(spec, setTrackStyle, function () {
	        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
	      });
	      // animating state should be cleared while resizing, otherwise autoplay stops working
	      _this.setState({
	        animating: false
	      });
	      clearTimeout(_this.animationEndCallback);
	      delete _this.animationEndCallback;
	    };
	
	    _this.updateState = function (spec, setTrackStyle, callback) {
	      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
	      spec = _extends({}, spec, updatedState, { slideIndex: updatedState.currentSlide });
	      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
	      spec = _extends({}, spec, { left: targetLeft });
	      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
	      if (setTrackStyle || _react2.default.Children.count(_this.props.children) !== _react2.default.Children.count(spec.children)) {
	        updatedState["trackStyle"] = trackStyle;
	      }
	      _this.setState(updatedState, callback);
	    };
	
	    _this.ssrInit = function () {
	      if (_this.props.variableWidth) {
	        var _trackWidth = 0,
	            _trackLeft = 0;
	        var childrenWidths = [];
	        var preClones = (0, _innerSliderUtils.getPreClones)(_extends({}, _this.props, _this.state, {
	          slideCount: _this.props.children.length
	        }));
	        var postClones = (0, _innerSliderUtils.getPostClones)(_extends({}, _this.props, _this.state, {
	          slideCount: _this.props.children.length
	        }));
	        _this.props.children.forEach(function (child) {
	          childrenWidths.push(child.props.style.width);
	          _trackWidth += child.props.style.width;
	        });
	        for (var i = 0; i < preClones; i++) {
	          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
	          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
	        }
	        for (var _i2 = 0; _i2 < postClones; _i2++) {
	          _trackWidth += childrenWidths[_i2];
	        }
	        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
	          _trackLeft += childrenWidths[_i3];
	        }
	        var _trackStyle = {
	          width: _trackWidth + "px",
	          left: -_trackLeft + "px"
	        };
	        if (_this.props.centerMode) {
	          var currentWidth = childrenWidths[_this.state.currentSlide] + "px";
	          _trackStyle.left = "calc(" + _trackStyle.left + " + (100% - " + currentWidth + ") / 2 ) ";
	        }
	        _this.setState({
	          trackStyle: _trackStyle
	        });
	        return;
	      }
	      var childrenCount = _react2.default.Children.count(_this.props.children);
	      var spec = _extends({}, _this.props, _this.state, { slideCount: childrenCount });
	      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
	      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
	      var slideWidth = 100 / slideCount;
	      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
	      if (_this.props.centerMode) {
	        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
	      }
	      var trackStyle = {
	        width: trackWidth + "%",
	        left: trackLeft + "%"
	      };
	      _this.setState({
	        slideWidth: slideWidth + "%",
	        trackStyle: trackStyle
	      });
	    };
	
	    _this.checkImagesLoad = function () {
	      var images = document.querySelectorAll(".slick-slide img");
	      var imagesCount = images.length,
	          loadedCount = 0;
	      Array.prototype.forEach.call(images, function (image) {
	        var handler = function handler() {
	          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
	        };
	        if (!image.onclick) {
	          image.onclick = function () {
	            return image.parentNode.focus();
	          };
	        } else {
	          var prevClickHandler = image.onclick;
	          image.onclick = function () {
	            prevClickHandler();
	            image.parentNode.focus();
	          };
	        }
	        if (!image.onload) {
	          if (_this.props.lazyLoad) {
	            image.onload = function () {
	              _this.adaptHeight();
	              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
	            };
	          } else {
	            image.onload = handler;
	            image.onerror = function () {
	              handler();
	              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
	            };
	          }
	        }
	      });
	    };
	
	    _this.progressiveLazyLoad = function () {
	      var slidesToLoad = [];
	      var spec = _extends({}, _this.props, _this.state);
	      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
	        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
	          slidesToLoad.push(index);
	          break;
	        }
	      }
	      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
	        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
	          slidesToLoad.push(_index);
	          break;
	        }
	      }
	      if (slidesToLoad.length > 0) {
	        _this.setState(function (state) {
	          return {
	            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
	          };
	        });
	        if (_this.props.onLazyLoad) {
	          _this.props.onLazyLoad(slidesToLoad);
	        }
	      } else {
	        if (_this.lazyLoadTimer) {
	          clearInterval(_this.lazyLoadTimer);
	          delete _this.lazyLoadTimer;
	        }
	      }
	    };
	
	    _this.slideHandler = function (index) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var _this$props = _this.props,
	          asNavFor = _this$props.asNavFor,
	          beforeChange = _this$props.beforeChange,
	          onLazyLoad = _this$props.onLazyLoad,
	          speed = _this$props.speed,
	          afterChange = _this$props.afterChange;
	      // capture currentslide before state is updated
	
	      var currentSlide = _this.state.currentSlide;
	
	      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_extends({
	        index: index
	      }, _this.props, _this.state, {
	        trackRef: _this.track,
	        useCSS: _this.props.useCSS && !dontAnimate
	      })),
	          state = _slideHandler.state,
	          nextState = _slideHandler.nextState;
	
	      if (!state) return;
	      beforeChange && beforeChange(currentSlide, state.currentSlide);
	      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
	        return _this.state.lazyLoadedList.indexOf(value) < 0;
	      });
	      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
	      _this.setState(state, function () {
	        asNavFor && asNavFor.innerSlider.state.currentSlide !== currentSlide && asNavFor.innerSlider.slideHandler(index);
	        if (!nextState) return;
	        _this.animationEndCallback = setTimeout(function () {
	          var animating = nextState.animating,
	              firstBatch = _objectWithoutProperties(nextState, ["animating"]);
	
	          _this.setState(firstBatch, function () {
	            _this.callbackTimers.push(setTimeout(function () {
	              return _this.setState({ animating: animating });
	            }, 10));
	            afterChange && afterChange(state.currentSlide);
	            delete _this.animationEndCallback;
	          });
	        }, speed);
	      });
	    };
	
	    _this.changeSlide = function (options) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var spec = _extends({}, _this.props, _this.state);
	      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
	      if (targetSlide !== 0 && !targetSlide) return;
	      if (dontAnimate === true) {
	        _this.slideHandler(targetSlide, dontAnimate);
	      } else {
	        _this.slideHandler(targetSlide);
	      }
	    };
	
	    _this.clickHandler = function (e) {
	      if (_this.clickable === false) {
	        e.stopPropagation();
	        e.preventDefault();
	      }
	      _this.clickable = true;
	    };
	
	    _this.keyHandler = function (e) {
	      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
	      dir !== "" && _this.changeSlide({ message: dir });
	    };
	
	    _this.selectHandler = function (options) {
	      _this.changeSlide(options);
	    };
	
	    _this.disableBodyScroll = function () {
	      var preventDefault = function preventDefault(e) {
	        e = e || window.event;
	        if (e.preventDefault) e.preventDefault();
	        e.returnValue = false;
	      };
	      window.ontouchmove = preventDefault;
	    };
	
	    _this.enableBodyScroll = function () {
	      window.ontouchmove = null;
	    };
	
	    _this.swipeStart = function (e) {
	      if (_this.props.verticalSwiping) {
	        _this.disableBodyScroll();
	      }
	      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
	      state !== "" && _this.setState(state);
	    };
	
	    _this.swipeMove = function (e) {
	      var state = (0, _innerSliderUtils.swipeMove)(e, _extends({}, _this.props, _this.state, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	      if (state["swiping"]) {
	        _this.clickable = false;
	      }
	      _this.setState(state);
	    };
	
	    _this.swipeEnd = function (e) {
	      var state = (0, _innerSliderUtils.swipeEnd)(e, _extends({}, _this.props, _this.state, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	      var triggerSlideHandler = state["triggerSlideHandler"];
	      delete state["triggerSlideHandler"];
	      _this.setState(state);
	      if (triggerSlideHandler === undefined) return;
	      _this.slideHandler(triggerSlideHandler);
	      if (_this.props.verticalSwiping) {
	        _this.enableBodyScroll();
	      }
	    };
	
	    _this.slickPrev = function () {
	      // this and fellow methods are wrapped in setTimeout
	      // to make sure initialize setState has happened before
	      // any of such methods are called
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({ message: "previous" });
	      }, 0));
	    };
	
	    _this.slickNext = function () {
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({ message: "next" });
	      }, 0));
	    };
	
	    _this.slickGoTo = function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      slide = Number(slide);
	      if (isNaN(slide)) return "";
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "index",
	          index: slide,
	          currentSlide: _this.state.currentSlide
	        }, dontAnimate);
	      }, 0));
	    };
	
	    _this.play = function () {
	      var nextIndex;
	      if (_this.props.rtl) {
	        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
	      } else {
	        if ((0, _innerSliderUtils.canGoNext)(_extends({}, _this.props, _this.state))) {
	          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
	        } else {
	          return false;
	        }
	      }
	
	      _this.slideHandler(nextIndex);
	    };
	
	    _this.autoPlay = function (playType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	      var autoplaying = _this.state.autoplaying;
	      if (playType === "update") {
	        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
	          return;
	        }
	      } else if (playType === "leave") {
	        if (autoplaying === "paused" || autoplaying === "focused") {
	          return;
	        }
	      } else if (playType === "blur") {
	        if (autoplaying === "paused" || autoplaying === "hovered") {
	          return;
	        }
	      }
	      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
	      _this.setState({ autoplaying: "playing" });
	    };
	
	    _this.pause = function (pauseType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	        _this.autoplayTimer = null;
	      }
	      var autoplaying = _this.state.autoplaying;
	      if (pauseType === "paused") {
	        _this.setState({ autoplaying: "paused" });
	      } else if (pauseType === "focused") {
	        if (autoplaying === "hovered" || autoplaying === "playing") {
	          _this.setState({ autoplaying: "focused" });
	        }
	      } else {
	        // pauseType  is 'hovered'
	        if (autoplaying === "playing") {
	          _this.setState({ autoplaying: "hovered" });
	        }
	      }
	    };
	
	    _this.onDotsOver = function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    };
	
	    _this.onDotsLeave = function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    };
	
	    _this.onTrackOver = function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    };
	
	    _this.onTrackLeave = function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    };
	
	    _this.onSlideFocus = function () {
	      return _this.props.autoplay && _this.pause("focused");
	    };
	
	    _this.onSlideBlur = function () {
	      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
	    };
	
	    _this.render = function () {
	      var className = (0, _classnames2.default)("slick-slider", _this.props.className, {
	        "slick-vertical": _this.props.vertical,
	        "slick-initialized": true
	      });
	      var spec = _extends({}, _this.props, _this.state);
	      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
	      var pauseOnHover = _this.props.pauseOnHover;
	
	      trackProps = _extends({}, trackProps, {
	        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
	        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
	        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
	        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
	      });
	
	      var dots;
	      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
	        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
	        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
	
	        dotProps = _extends({}, dotProps, {
	          clickHandler: _this.changeSlide,
	          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
	          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
	          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
	        });
	        dots = _react2.default.createElement(_dots.Dots, dotProps);
	      }
	
	      var prevArrow, nextArrow;
	      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
	      arrowProps.clickHandler = _this.changeSlide;
	
	      if (_this.props.arrows) {
	        prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
	        nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
	      }
	
	      var verticalHeightStyle = null;
	
	      if (_this.props.vertical) {
	        verticalHeightStyle = {
	          height: _this.state.listHeight
	        };
	      }
	
	      var centerPaddingStyle = null;
	
	      if (_this.props.vertical === false) {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: "0px " + _this.props.centerPadding
	          };
	        }
	      } else {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: _this.props.centerPadding + " 0px"
	          };
	        }
	      }
	
	      var listStyle = _extends({}, verticalHeightStyle, centerPaddingStyle);
	      var touchMove = _this.props.touchMove;
	      var listProps = {
	        className: "slick-list",
	        style: listStyle,
	        onClick: _this.clickHandler,
	        onMouseDown: touchMove ? _this.swipeStart : null,
	        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onMouseUp: touchMove ? _this.swipeEnd : null,
	        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onTouchStart: touchMove ? _this.swipeStart : null,
	        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onTouchEnd: touchMove ? _this.swipeEnd : null,
	        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
	      };
	
	      var innerSliderProps = {
	        className: className,
	        dir: "ltr"
	      };
	
	      if (_this.props.unslick) {
	        listProps = { className: "slick-list" };
	        innerSliderProps = { className: className };
	      }
	      return _react2.default.createElement(
	        "div",
	        innerSliderProps,
	        !_this.props.unslick ? prevArrow : "",
	        _react2.default.createElement(
	          "div",
	          _extends({ ref: _this.listRefHandler }, listProps),
	          _react2.default.createElement(
	            _track.Track,
	            _extends({ ref: _this.trackRefHandler }, trackProps),
	            _this.props.children
	          )
	        ),
	        !_this.props.unslick ? nextArrow : "",
	        !_this.props.unslick ? dots : ""
	      );
	    };
	
	    _this.list = null;
	    _this.track = null;
	    _this.state = _extends({}, _initialState2.default, {
	      currentSlide: _this.props.initialSlide,
	      slideCount: _react2.default.Children.count(_this.props.children)
	    });
	    _this.callbackTimers = [];
	    _this.clickable = true;
	    _this.debouncedResize = null;
	    return _this;
	  }
	
	  return InnerSlider;
	}(_react2.default.Component);

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _innerSlider = __webpack_require__(69);
	
	var _json2mq = __webpack_require__(62);
	
	var _json2mq2 = _interopRequireDefault(_json2mq);
	
	var _defaultProps = __webpack_require__(65);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _innerSliderUtils = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(59);
	
	var Slider = function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  function Slider(props) {
	    _classCallCheck(this, Slider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.innerSliderRefHandler = function (ref) {
	      return _this.innerSlider = ref;
	    };
	
	    _this.slickPrev = function () {
	      return _this.innerSlider.slickPrev();
	    };
	
	    _this.slickNext = function () {
	      return _this.innerSlider.slickNext();
	    };
	
	    _this.slickGoTo = function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      return _this.innerSlider.slickGoTo(slide, dontAnimate);
	    };
	
	    _this.slickPause = function () {
	      return _this.innerSlider.pause("paused");
	    };
	
	    _this.slickPlay = function () {
	      return _this.innerSlider.autoPlay("play");
	    };
	
	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    return _this;
	  }
	
	  Slider.prototype.media = function media(query, handler) {
	    // javascript handler for  css media query
	    enquire.register(query, handler);
	    this._responsiveMediaHandlers.push({ query: query, handler: handler });
	  };
	
	  // handles responsive breakpoints
	
	
	  Slider.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    // performance monitoring
	    //if (process.env.NODE_ENV !== 'production') {
	    //const { whyDidYouUpdate } = require('why-did-you-update')
	    //whyDidYouUpdate(React)
	    //}
	    if (this.props.responsive) {
	      var breakpoints = this.props.responsive.map(function (breakpt) {
	        return breakpt.breakpoint;
	      });
	      // sort them in increasing order of their numerical value
	      breakpoints.sort(function (x, y) {
	        return x - y;
	      });
	
	      breakpoints.forEach(function (breakpoint, index) {
	        // media query for each breakpoint
	        var bQuery = void 0;
	        if (index === 0) {
	          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
	        } else {
	          bQuery = (0, _json2mq2.default)({
	            minWidth: breakpoints[index - 1] + 1,
	            maxWidth: breakpoint
	          });
	        }
	        // when not using server side rendering
	        (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
	          _this2.setState({ breakpoint: breakpoint });
	        });
	      });
	
	      // Register media query for full screen. Need to support resize from small to large
	      // convert javascript object to media query string
	      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });
	
	      (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
	        _this2.setState({ breakpoint: null });
	      });
	    }
	  };
	
	  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._responsiveMediaHandlers.forEach(function (obj) {
	      enquire.unregister(obj.query, obj.handler);
	    });
	  };
	
	  Slider.prototype.render = function render() {
	    var _this3 = this;
	
	    var settings;
	    var newProps;
	    if (this.state.breakpoint) {
	      newProps = this.props.responsive.filter(function (resp) {
	        return resp.breakpoint === _this3.state.breakpoint;
	      });
	      settings = newProps[0].settings === "unslick" ? "unslick" : _extends({}, _defaultProps2.default, this.props, newProps[0].settings);
	    } else {
	      settings = _extends({}, _defaultProps2.default, this.props);
	    }
	
	    // force scrolling by one if centerMode is on
	    if (settings.centerMode) {
	      if (settings.slidesToScroll > 1 && ("production") !== "production") {
	        console.warn("slidesToScroll should be equal to 1 in centerMode, you are using " + settings.slidesToScroll);
	      }
	      settings.slidesToScroll = 1;
	    }
	    // force showing one slide and scrolling by one if the fade mode is on
	    if (settings.fade) {
	      if (settings.slidesToShow > 1 && ("production") !== "production") {
	        console.warn("slidesToShow should be equal to 1 when fade is true, you're using " + settings.slidesToShow);
	      }
	      if (settings.slidesToScroll > 1 && ("production") !== "production") {
	        console.warn("slidesToScroll should be equal to 1 when fade is true, you're using " + settings.slidesToScroll);
	      }
	      settings.slidesToShow = 1;
	      settings.slidesToScroll = 1;
	    }
	
	    // makes sure that children is an array, even when there is only 1 child
	    var children = _react2.default.Children.toArray(this.props.children);
	
	    // Children may contain false or null, so we should filter them
	    // children may also contain string filled with spaces (in certain cases where we use jsx strings)
	    children = children.filter(function (child) {
	      if (typeof child === "string") {
	        return !!child.trim();
	      }
	      return !!child;
	    });
	
	    // rows and slidesPerRow logic is handled here
	    if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
	      console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
	      settings.variableWidth = false;
	    }
	    var newChildren = [];
	    var currentWidth = null;
	    for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
	      var newSlide = [];
	      for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
	        var row = [];
	        for (var k = j; k < j + settings.slidesPerRow; k += 1) {
	          if (settings.variableWidth && children[k].props.style) {
	            currentWidth = children[k].props.style.width;
	          }
	          if (k >= children.length) break;
	          row.push(_react2.default.cloneElement(children[k], {
	            key: 100 * i + 10 * j + k,
	            tabIndex: -1,
	            style: {
	              width: 100 / settings.slidesPerRow + "%",
	              display: "inline-block"
	            }
	          }));
	        }
	        newSlide.push(_react2.default.createElement(
	          "div",
	          { key: 10 * i + j },
	          row
	        ));
	      }
	      if (settings.variableWidth) {
	        newChildren.push(_react2.default.createElement(
	          "div",
	          { key: i, style: { width: currentWidth } },
	          newSlide
	        ));
	      } else {
	        newChildren.push(_react2.default.createElement(
	          "div",
	          { key: i },
	          newSlide
	        ));
	      }
	    }
	
	    if (settings === "unslick") {
	      var className = "regular slider " + (this.props.className || "");
	      return _react2.default.createElement(
	        "div",
	        { className: className },
	        newChildren
	      );
	    } else if (newChildren.length <= settings.slidesToShow) {
	      settings.unslick = true;
	    }
	    return _react2.default.createElement(
	      _innerSlider.InnerSlider,
	      _extends({ ref: this.innerSliderRefHandler }, settings),
	      newChildren
	    );
	  };
	
	  return Slider;
	}(_react2.default.Component);
	
	exports.default = Slider;

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Track = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(15);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _innerSliderUtils = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
	var getSlideClasses = function getSlideClasses(spec) {
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;
	
	  if (spec.rtl) {
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    index = spec.index;
	  }
	  slickCloned = index < 0 || index >= spec.slideCount;
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	  var slickCurrent = index === spec.currentSlide;
	  return {
	    "slick-slide": true,
	    "slick-active": slickActive,
	    "slick-center": slickCenter,
	    "slick-cloned": slickCloned,
	    "slick-current": slickCurrent // dubious in case of RTL
	  };
	};
	
	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};
	
	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }
	
	  if (spec.fade) {
	    style.position = "relative";
	    if (spec.vertical) {
	      style.top = -spec.index * parseInt(spec.slideHeight);
	    } else {
	      style.left = -spec.index * parseInt(spec.slideWidth);
	    }
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
	    style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
	  }
	
	  return style;
	};
	
	var getKey = function getKey(child, fallbackKey) {
	  return child.key || fallbackKey;
	};
	
	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	  var childrenCount = _react2.default.Children.count(spec.children);
	  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
	  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);
	
	  _react2.default.Children.forEach(spec.children, function (elem, index) {
	    var child = void 0;
	    var childOnClickOptions = {
	      message: "children",
	      index: index,
	      slidesToScroll: spec.slidesToScroll,
	      currentSlide: spec.currentSlide
	    };
	
	    // in case of lazyLoad, whether or not we want to fetch the slide
	    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
	      child = elem;
	    } else {
	      child = _react2.default.createElement("div", null);
	    }
	    var childStyle = getSlideStyle(_extends({}, spec, { index: index }));
	    var slideClass = child.props.className || "";
	    var slideClasses = getSlideClasses(_extends({}, spec, { index: index }));
	    // push a cloned element of the desired slide
	    slides.push(_react2.default.cloneElement(child, {
	      key: "original" + getKey(child, index),
	      "data-index": index,
	      className: (0, _classnames2.default)(slideClasses, slideClass),
	      tabIndex: "-1",
	      "aria-hidden": !slideClasses["slick-active"],
	      style: _extends({ outline: "none" }, child.props.style || {}, childStyle),
	      onClick: function onClick(e) {
	        child.props && child.props.onClick && child.props.onClick(e);
	        if (spec.focusOnSelect) {
	          spec.focusOnSelect(childOnClickOptions);
	        }
	      }
	    }));
	
	    // if slide needs to be precloned or postcloned
	    if (spec.infinite && spec.fade === false) {
	      var preCloneNo = childrenCount - index;
	      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
	        key = -preCloneNo;
	        if (key >= startIndex) {
	          child = elem;
	        }
	        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
	        preCloneSlides.push(_react2.default.cloneElement(child, {
	          key: "precloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames2.default)(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _extends({}, child.props.style || {}, childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	
	      if (childrenCount !== spec.slidesToShow) {
	        key = childrenCount + index;
	        if (key < endIndex) {
	          child = elem;
	        }
	        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
	        postCloneSlides.push(_react2.default.cloneElement(child, {
	          key: "postcloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames2.default)(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _extends({}, child.props.style || {}, childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	    }
	  });
	
	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};
	
	var Track = exports.Track = function (_React$PureComponent) {
	  _inherits(Track, _React$PureComponent);
	
	  function Track() {
	    _classCallCheck(this, Track);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  Track.prototype.render = function render() {
	    var slides = renderSlides(this.props);
	    var _props = this.props,
	        onMouseEnter = _props.onMouseEnter,
	        onMouseOver = _props.onMouseOver,
	        onMouseLeave = _props.onMouseLeave;
	
	    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
	    return _react2.default.createElement(
	      "div",
	      _extends({
	        className: "slick-track",
	        style: this.props.trackStyle
	      }, mouseEvents),
	      slides
	    );
	  };
	
	  return Track;
	}(_react2.default.PureComponent);

/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(29);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getOnDemandLazySlides = exports.getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
	  var onDemandSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
	      onDemandSlides.push(slideIndex);
	    }
	  }
	  return onDemandSlides;
	};
	
	// return list of slides that need to be present
	var getRequiredLazySlides = exports.getRequiredLazySlides = function getRequiredLazySlides(spec) {
	  var requiredSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    requiredSlides.push(slideIndex);
	  }
	  return requiredSlides;
	};
	
	// startIndex that needs to be present
	var lazyStartIndex = exports.lazyStartIndex = function lazyStartIndex(spec) {
	  return spec.currentSlide - lazySlidesOnLeft(spec);
	};
	var lazyEndIndex = exports.lazyEndIndex = function lazyEndIndex(spec) {
	  return spec.currentSlide + lazySlidesOnRight(spec);
	};
	var lazySlidesOnLeft = exports.lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
	  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
	};
	var lazySlidesOnRight = exports.lazySlidesOnRight = function lazySlidesOnRight(spec) {
	  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
	};
	
	// get width of an element
	var getWidth = exports.getWidth = function getWidth(elem) {
	  return elem && elem.offsetWidth || 0;
	};
	var getHeight = exports.getHeight = function getHeight(elem) {
	  return elem && elem.offsetHeight || 0;
	};
	var getSwipeDirection = exports.getSwipeDirection = function getSwipeDirection(touchObject) {
	  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var xDist, yDist, r, swipeAngle;
	  xDist = touchObject.startX - touchObject.curX;
	  yDist = touchObject.startY - touchObject.curY;
	  r = Math.atan2(yDist, xDist);
	  swipeAngle = Math.round(r * 180 / Math.PI);
	  if (swipeAngle < 0) {
	    swipeAngle = 360 - Math.abs(swipeAngle);
	  }
	  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	    return "left";
	  }
	  if (swipeAngle >= 135 && swipeAngle <= 225) {
	    return "right";
	  }
	  if (verticalSwiping === true) {
	    if (swipeAngle >= 35 && swipeAngle <= 135) {
	      return "up";
	    } else {
	      return "down";
	    }
	  }
	
	  return "vertical";
	};
	
	// whether or not we can go next
	var canGoNext = exports.canGoNext = function canGoNext(spec) {
	  var canGo = true;
	  if (!spec.infinite) {
	    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
	      canGo = false;
	    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
	      canGo = false;
	    }
	  }
	  return canGo;
	};
	
	// given an object and a list of keys, return new object with given keys
	var extractObject = exports.extractObject = function extractObject(spec, keys) {
	  var newObject = {};
	  keys.forEach(function (key) {
	    return newObject[key] = spec[key];
	  });
	  return newObject;
	};
	
	// get initialized state
	var initializedState = exports.initializedState = function initializedState(spec) {
	  // spec also contains listRef, trackRef
	  var slideCount = _react2.default.Children.count(spec.children);
	  var listWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.listRef)));
	  var trackWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.trackRef)));
	  var slideWidth = void 0;
	  if (!spec.vertical) {
	    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
	    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
	      centerPaddingAdj *= listWidth / 100;
	    }
	    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
	  } else {
	    slideWidth = listWidth;
	  }
	  var slideHeight = _reactDom2.default.findDOMNode(spec.listRef) && getHeight(_reactDom2.default.findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
	  var listHeight = slideHeight * spec.slidesToShow;
	  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
	  if (spec.rtl && spec.currentSlide === undefined) {
	    currentSlide = slideCount - 1 - spec.initialSlide;
	  }
	  var lazyLoadedList = spec.lazyLoadedList || [];
	  var slidesToLoad = getOnDemandLazySlides({ currentSlide: currentSlide, lazyLoadedList: lazyLoadedList }, spec);
	  lazyLoadedList.concat(slidesToLoad);
	
	  var state = {
	    slideCount: slideCount,
	    slideWidth: slideWidth,
	    listWidth: listWidth,
	    trackWidth: trackWidth,
	    currentSlide: currentSlide,
	    slideHeight: slideHeight,
	    listHeight: listHeight,
	    lazyLoadedList: lazyLoadedList
	  };
	
	  if (spec.autoplaying === null && spec.autoplay) {
	    state["autoplaying"] = "playing";
	  }
	
	  return state;
	};
	
	var slideHandler = exports.slideHandler = function slideHandler(spec) {
	  var waitForAnimate = spec.waitForAnimate,
	      animating = spec.animating,
	      fade = spec.fade,
	      infinite = spec.infinite,
	      index = spec.index,
	      slideCount = spec.slideCount,
	      lazyLoadedList = spec.lazyLoadedList,
	      lazyLoad = spec.lazyLoad,
	      currentSlide = spec.currentSlide,
	      centerMode = spec.centerMode,
	      slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      useCSS = spec.useCSS;
	
	  if (waitForAnimate && animating) return {};
	  var animationSlide = index,
	      finalSlide = void 0,
	      animationLeft = void 0,
	      finalLeft = void 0;
	  var state = {},
	      nextState = {};
	  if (fade) {
	    if (!infinite && (index < 0 || index >= slideCount)) return {};
	    if (index < 0) {
	      animationSlide = index + slideCount;
	    } else if (index >= slideCount) {
	      animationSlide = index - slideCount;
	    }
	    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
	      lazyLoadedList.push(animationSlide);
	    }
	    state = {
	      animating: true,
	      currentSlide: animationSlide,
	      lazyLoadedList: lazyLoadedList
	    };
	    nextState = { animating: false };
	  } else {
	    finalSlide = animationSlide;
	    if (animationSlide < 0) {
	      finalSlide = animationSlide + slideCount;
	      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
	    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
	      animationSlide = finalSlide = currentSlide;
	    } else if (centerMode && animationSlide >= slideCount) {
	      animationSlide = infinite ? slideCount : slideCount - 1;
	      finalSlide = infinite ? 0 : slideCount - 1;
	    } else if (animationSlide >= slideCount) {
	      finalSlide = animationSlide - slideCount;
	      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
	    }
	    animationLeft = getTrackLeft(_extends({}, spec, { slideIndex: animationSlide }));
	    finalLeft = getTrackLeft(_extends({}, spec, { slideIndex: finalSlide }));
	    if (!infinite) {
	      if (animationLeft === finalLeft) animationSlide = finalSlide;
	      animationLeft = finalLeft;
	    }
	    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_extends({}, spec, { currentSlide: animationSlide })));
	    if (!useCSS) {
	      state = {
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
	        lazyLoadedList: lazyLoadedList
	      };
	    } else {
	      state = {
	        animating: true,
	        currentSlide: finalSlide,
	        trackStyle: getTrackAnimateCSS(_extends({}, spec, { left: animationLeft })),
	        lazyLoadedList: lazyLoadedList
	      };
	      nextState = {
	        animating: false,
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
	        swipeLeft: null
	      };
	    }
	  }
	  return { state: state, nextState: nextState };
	};
	
	var changeSlide = exports.changeSlide = function changeSlide(spec, options) {
	  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	  var slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      slideCount = spec.slideCount,
	      currentSlide = spec.currentSlide,
	      lazyLoad = spec.lazyLoad,
	      infinite = spec.infinite;
	
	  unevenOffset = slideCount % slidesToScroll !== 0;
	  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
	
	  if (options.message === "previous") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
	    targetSlide = currentSlide - slideOffset;
	    if (lazyLoad && !infinite) {
	      previousInt = currentSlide - slideOffset;
	      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
	    }
	  } else if (options.message === "next") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
	    targetSlide = currentSlide + slideOffset;
	    if (lazyLoad && !infinite) {
	      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
	    }
	  } else if (options.message === "dots") {
	    // Click on dots
	    targetSlide = options.index * options.slidesToScroll;
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	  } else if (options.message === "children") {
	    // Click on the slides
	    targetSlide = options.index;
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	    if (infinite) {
	      var direction = siblingDirection(_extends({}, spec, { targetSlide: targetSlide }));
	      if (targetSlide > options.currentSlide && direction === "left") {
	        targetSlide = targetSlide - slideCount;
	      } else if (targetSlide < options.currentSlide && direction === "right") {
	        targetSlide = targetSlide + slideCount;
	      }
	    }
	  } else if (options.message === "index") {
	    targetSlide = Number(options.index);
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	  }
	  return targetSlide;
	};
	var keyHandler = exports.keyHandler = function keyHandler(e, accessibility, rtl) {
	  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
	  if (e.keyCode === 37) return rtl ? "next" : "previous";
	  if (e.keyCode === 39) return rtl ? "previous" : "next";
	  return "";
	};
	
	var swipeStart = exports.swipeStart = function swipeStart(e, swipe, draggable) {
	  e.target.tagName === "IMG" && e.preventDefault();
	  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
	  return {
	    dragging: true,
	    touchObject: {
	      startX: e.touches ? e.touches[0].pageX : e.clientX,
	      startY: e.touches ? e.touches[0].pageY : e.clientY,
	      curX: e.touches ? e.touches[0].pageX : e.clientX,
	      curY: e.touches ? e.touches[0].pageY : e.clientY
	    }
	  };
	};
	var swipeMove = exports.swipeMove = function swipeMove(e, spec) {
	  // spec also contains, trackRef and slideIndex
	  var scrolling = spec.scrolling,
	      animating = spec.animating,
	      vertical = spec.vertical,
	      swipeToSlide = spec.swipeToSlide,
	      verticalSwiping = spec.verticalSwiping,
	      rtl = spec.rtl,
	      currentSlide = spec.currentSlide,
	      edgeFriction = spec.edgeFriction,
	      edgeDragged = spec.edgeDragged,
	      onEdge = spec.onEdge,
	      swiped = spec.swiped,
	      swiping = spec.swiping,
	      slideCount = spec.slideCount,
	      slidesToScroll = spec.slidesToScroll,
	      infinite = spec.infinite,
	      touchObject = spec.touchObject,
	      swipeEvent = spec.swipeEvent,
	      listHeight = spec.listHeight,
	      listWidth = spec.listWidth;
	
	  if (scrolling) return;
	  if (animating) return e.preventDefault();
	  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
	  var swipeLeft = void 0,
	      state = {};
	  var curLeft = getTrackLeft(spec);
	  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
	  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
	    return { scrolling: true };
	  }
	  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
	  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
	
	  var dotCount = Math.ceil(slideCount / slidesToScroll);
	  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
	  var touchSwipeLength = touchObject.swipeLength;
	  if (!infinite) {
	    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
	      touchSwipeLength = touchObject.swipeLength * edgeFriction;
	      if (edgeDragged === false && onEdge) {
	        onEdge(swipeDirection);
	        state["edgeDragged"] = true;
	      }
	    }
	  }
	  if (!swiped && swipeEvent) {
	    swipeEvent(swipeDirection);
	    state["swiped"] = true;
	  }
	  if (!vertical) {
	    if (!rtl) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    } else {
	      swipeLeft = curLeft - touchSwipeLength * positionOffset;
	    }
	  } else {
	    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
	  }
	  if (verticalSwiping) {
	    swipeLeft = curLeft + touchSwipeLength * positionOffset;
	  }
	  state = _extends({}, state, {
	    touchObject: touchObject,
	    swipeLeft: swipeLeft,
	    trackStyle: getTrackCSS(_extends({}, spec, { left: swipeLeft }))
	  });
	  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	    return state;
	  }
	  if (touchObject.swipeLength > 10) {
	    state["swiping"] = true;
	    e.preventDefault();
	  }
	  return state;
	};
	var swipeEnd = exports.swipeEnd = function swipeEnd(e, spec) {
	  var dragging = spec.dragging,
	      swipe = spec.swipe,
	      touchObject = spec.touchObject,
	      listWidth = spec.listWidth,
	      touchThreshold = spec.touchThreshold,
	      verticalSwiping = spec.verticalSwiping,
	      listHeight = spec.listHeight,
	      currentSlide = spec.currentSlide,
	      swipeToSlide = spec.swipeToSlide,
	      scrolling = spec.scrolling,
	      onSwipe = spec.onSwipe;
	
	  if (!dragging) {
	    if (swipe) e.preventDefault();
	    return {};
	  }
	  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
	  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping);
	  // reset the state of touch related state variables.
	  var state = {
	    dragging: false,
	    edgeDragged: false,
	    scrolling: false,
	    swiping: false,
	    swiped: false,
	    swipeLeft: null,
	    touchObject: {}
	  };
	  if (scrolling) {
	    return state;
	  }
	  if (!touchObject.swipeLength) {
	    return state;
	  }
	  if (touchObject.swipeLength > minSwipe) {
	    e.preventDefault();
	    if (onSwipe) {
	      onSwipe(swipeDirection);
	    }
	    var slideCount = void 0,
	        newSlide = void 0;
	    switch (swipeDirection) {
	      case "left":
	      case "up":
	        newSlide = currentSlide + getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 0;
	        break;
	      case "right":
	      case "down":
	        newSlide = currentSlide - getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 1;
	        break;
	      default:
	        slideCount = currentSlide;
	    }
	    state["triggerSlideHandler"] = slideCount;
	  } else {
	    // Adjust the track back to it's original position.
	    var currentLeft = getTrackLeft(spec);
	    state["trackStyle"] = getTrackAnimateCSS(_extends({}, spec, { left: currentLeft }));
	  }
	  return state;
	};
	var getNavigableIndexes = exports.getNavigableIndexes = function getNavigableIndexes(spec) {
	  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
	  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var indexes = [];
	  while (breakpoint < max) {
	    indexes.push(breakpoint);
	    breakpoint = counter + spec.slidesToScroll;
	    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
	  }
	  return indexes;
	};
	var checkNavigable = exports.checkNavigable = function checkNavigable(spec, index) {
	  var navigables = getNavigableIndexes(spec);
	  var prevNavigable = 0;
	  if (index > navigables[navigables.length - 1]) {
	    index = navigables[navigables.length - 1];
	  } else {
	    for (var n in navigables) {
	      if (index < navigables[n]) {
	        index = prevNavigable;
	        break;
	      }
	      prevNavigable = navigables[n];
	    }
	  }
	  return index;
	};
	var getSlideCount = exports.getSlideCount = function getSlideCount(spec) {
	  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
	  if (spec.swipeToSlide) {
	    var swipedSlide = void 0;
	    var slickList = _reactDom2.default.findDOMNode(spec.listRef);
	    var slides = slickList.querySelectorAll(".slick-slide");
	    Array.from(slides).every(function (slide) {
	      if (!spec.vertical) {
	        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      } else {
	        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      }
	
	      return true;
	    });
	
	    if (!swipedSlide) {
	      return 0;
	    }
	    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
	    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
	    return slidesTraversed;
	  } else {
	    return spec.slidesToScroll;
	  }
	};
	
	var checkSpecKeys = exports.checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error("Keys Missing:", spec);
	};
	
	var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
	  var trackWidth = void 0,
	      trackHeight = void 0;
	  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
	  if (!spec.vertical) {
	    trackWidth = getTotalSlides(spec) * spec.slideWidth;
	  } else {
	    trackHeight = trackChildren * spec.slideHeight;
	  }
	  var style = {
	    opacity: 1,
	    transition: "",
	    WebkitTransition: ""
	  };
	  if (spec.useTransform) {
	    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
	    style = _extends({}, style, {
	      WebkitTransform: WebkitTransform,
	      transform: transform,
	      msTransform: msTransform
	    });
	  } else {
	    if (spec.vertical) {
	      style["top"] = spec.left;
	    } else {
	      style["left"] = spec.left;
	    }
	  }
	  if (spec.fade) style = { opacity: 1 };
	  if (trackWidth) style.width = trackWidth;
	  if (trackHeight) style.height = trackHeight;
	
	  // Fallback for IE8
	  if (window && !window.addEventListener && window.attachEvent) {
	    if (!spec.vertical) {
	      style.marginLeft = spec.left + "px";
	    } else {
	      style.marginTop = spec.left + "px";
	    }
	  }
	
	  return style;
	};
	var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
	  var style = getTrackCSS(spec);
	  // useCSS is true by default so it can be undefined
	  if (spec.useTransform) {
	    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
	    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
	  } else {
	    if (spec.vertical) {
	      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
	    } else {
	      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
	    }
	  }
	  return style;
	};
	var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
	  if (spec.unslick) {
	    return 0;
	  }
	
	  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
	
	  var slideIndex = spec.slideIndex,
	      trackRef = spec.trackRef,
	      infinite = spec.infinite,
	      centerMode = spec.centerMode,
	      slideCount = spec.slideCount,
	      slidesToShow = spec.slidesToShow,
	      slidesToScroll = spec.slidesToScroll,
	      slideWidth = spec.slideWidth,
	      listWidth = spec.listWidth,
	      variableWidth = spec.variableWidth,
	      slideHeight = spec.slideHeight,
	      fade = spec.fade,
	      vertical = spec.vertical;
	
	
	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	  var verticalOffset = 0;
	
	  if (fade || spec.slideCount === 1) {
	    return 0;
	  }
	
	  var slidesToOffset = 0;
	  if (infinite) {
	    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
	    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
	    }
	    // shift current slide to center of the frame
	    if (centerMode) {
	      slidesToOffset += parseInt(slidesToShow / 2);
	    }
	  } else {
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
	    }
	    if (centerMode) {
	      slidesToOffset = parseInt(slidesToShow / 2);
	    }
	  }
	  slideOffset = slidesToOffset * slideWidth;
	  verticalOffset = slidesToOffset * slideHeight;
	
	  if (!vertical) {
	    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
	  } else {
	    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
	  }
	
	  if (variableWidth === true) {
	    var targetSlideIndex;
	    var trackElem = _reactDom2.default.findDOMNode(trackRef);
	    targetSlideIndex = slideIndex + getPreClones(spec);
	    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	    if (centerMode === true) {
	      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
	      targetSlide = trackElem && trackElem.children[targetSlideIndex];
	      targetLeft = 0;
	      for (var slide = 0; slide < targetSlideIndex; slide++) {
	        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
	      }
	      targetLeft -= parseInt(spec.centerPadding);
	      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
	    }
	  }
	
	  return targetLeft;
	};
	
	var getPreClones = exports.getPreClones = function getPreClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	  if (spec.variableWidth) {
	    return spec.slideCount;
	  }
	  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
	};
	
	var getPostClones = exports.getPostClones = function getPostClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	  return spec.slideCount;
	};
	
	var getTotalSlides = exports.getTotalSlides = function getTotalSlides(spec) {
	  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
	};
	var siblingDirection = exports.siblingDirection = function siblingDirection(spec) {
	  if (spec.targetSlide > spec.currentSlide) {
	    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
	      return "left";
	    }
	    return "right";
	  } else {
	    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
	      return "right";
	    }
	    return "left";
	  }
	};
	
	var slidesOnRight = exports.slidesOnRight = function slidesOnRight(_ref) {
	  var slidesToShow = _ref.slidesToShow,
	      centerMode = _ref.centerMode,
	      rtl = _ref.rtl,
	      centerPadding = _ref.centerPadding;
	
	  // returns no of slides on the right of active slide
	  if (centerMode) {
	    var right = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) right += 1;
	    if (rtl && slidesToShow % 2 === 0) right += 1;
	    return right;
	  }
	  if (rtl) {
	    return 0;
	  }
	  return slidesToShow - 1;
	};
	
	var slidesOnLeft = exports.slidesOnLeft = function slidesOnLeft(_ref2) {
	  var slidesToShow = _ref2.slidesToShow,
	      centerMode = _ref2.centerMode,
	      rtl = _ref2.rtl,
	      centerPadding = _ref2.centerPadding;
	
	  // returns no of slides on the left of active slide
	  if (centerMode) {
	    var left = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) left += 1;
	    if (!rtl && slidesToShow % 2 === 0) left += 1;
	    return left;
	  }
	  if (rtl) {
	    return slidesToShow - 1;
	  }
	  return 0;
	};
	
	var canUseDOM = exports.canUseDOM = function canUseDOM() {
	  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
	};

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	    /**
	     * A collection of shims that provide minimal functionality of the ES6 collections.
	     *
	     * These implementations are not meant to be used outside of the ResizeObserver
	     * modules as they cover only a limited range of use cases.
	     */
	    /* eslint-disable require-jsdoc, valid-jsdoc */
	    var MapShim = (function () {
	        if (typeof Map !== 'undefined') {
	            return Map;
	        }
	        /**
	         * Returns index in provided array that matches the specified key.
	         *
	         * @param {Array<Array>} arr
	         * @param {*} key
	         * @returns {number}
	         */
	        function getIndex(arr, key) {
	            var result = -1;
	            arr.some(function (entry, index) {
	                if (entry[0] === key) {
	                    result = index;
	                    return true;
	                }
	                return false;
	            });
	            return result;
	        }
	        return /** @class */ (function () {
	            function class_1() {
	                this.__entries__ = [];
	            }
	            Object.defineProperty(class_1.prototype, "size", {
	                /**
	                 * @returns {boolean}
	                 */
	                get: function () {
	                    return this.__entries__.length;
	                },
	                enumerable: true,
	                configurable: true
	            });
	            /**
	             * @param {*} key
	             * @returns {*}
	             */
	            class_1.prototype.get = function (key) {
	                var index = getIndex(this.__entries__, key);
	                var entry = this.__entries__[index];
	                return entry && entry[1];
	            };
	            /**
	             * @param {*} key
	             * @param {*} value
	             * @returns {void}
	             */
	            class_1.prototype.set = function (key, value) {
	                var index = getIndex(this.__entries__, key);
	                if (~index) {
	                    this.__entries__[index][1] = value;
	                }
	                else {
	                    this.__entries__.push([key, value]);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.delete = function (key) {
	                var entries = this.__entries__;
	                var index = getIndex(entries, key);
	                if (~index) {
	                    entries.splice(index, 1);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.has = function (key) {
	                return !!~getIndex(this.__entries__, key);
	            };
	            /**
	             * @returns {void}
	             */
	            class_1.prototype.clear = function () {
	                this.__entries__.splice(0);
	            };
	            /**
	             * @param {Function} callback
	             * @param {*} [ctx=null]
	             * @returns {void}
	             */
	            class_1.prototype.forEach = function (callback, ctx) {
	                if (ctx === void 0) { ctx = null; }
	                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
	                    var entry = _a[_i];
	                    callback.call(ctx, entry[1], entry[0]);
	                }
	            };
	            return class_1;
	        }());
	    })();
	
	    /**
	     * Detects whether window and document objects are available in current environment.
	     */
	    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	    // Returns global object of a current environment.
	    var global$1 = (function () {
	        if (typeof global !== 'undefined' && global.Math === Math) {
	            return global;
	        }
	        if (typeof self !== 'undefined' && self.Math === Math) {
	            return self;
	        }
	        if (typeof window !== 'undefined' && window.Math === Math) {
	            return window;
	        }
	        // eslint-disable-next-line no-new-func
	        return Function('return this')();
	    })();
	
	    /**
	     * A shim for the requestAnimationFrame which falls back to the setTimeout if
	     * first one is not supported.
	     *
	     * @returns {number} Requests' identifier.
	     */
	    var requestAnimationFrame$1 = (function () {
	        if (typeof requestAnimationFrame === 'function') {
	            // It's required to use a bounded function because IE sometimes throws
	            // an "Invalid calling object" error if rAF is invoked without the global
	            // object on the left hand side.
	            return requestAnimationFrame.bind(global$1);
	        }
	        return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	    })();
	
	    // Defines minimum timeout before adding a trailing call.
	    var trailingTimeout = 2;
	    /**
	     * Creates a wrapper function which ensures that provided callback will be
	     * invoked only once during the specified delay period.
	     *
	     * @param {Function} callback - Function to be invoked after the delay period.
	     * @param {number} delay - Delay after which to invoke callback.
	     * @returns {Function}
	     */
	    function throttle (callback, delay) {
	        var leadingCall = false, trailingCall = false, lastCallTime = 0;
	        /**
	         * Invokes the original callback function and schedules new invocation if
	         * the "proxy" was called during current request.
	         *
	         * @returns {void}
	         */
	        function resolvePending() {
	            if (leadingCall) {
	                leadingCall = false;
	                callback();
	            }
	            if (trailingCall) {
	                proxy();
	            }
	        }
	        /**
	         * Callback invoked after the specified delay. It will further postpone
	         * invocation of the original function delegating it to the
	         * requestAnimationFrame.
	         *
	         * @returns {void}
	         */
	        function timeoutCallback() {
	            requestAnimationFrame$1(resolvePending);
	        }
	        /**
	         * Schedules invocation of the original function.
	         *
	         * @returns {void}
	         */
	        function proxy() {
	            var timeStamp = Date.now();
	            if (leadingCall) {
	                // Reject immediately following calls.
	                if (timeStamp - lastCallTime < trailingTimeout) {
	                    return;
	                }
	                // Schedule new call to be in invoked when the pending one is resolved.
	                // This is important for "transitions" which never actually start
	                // immediately so there is a chance that we might miss one if change
	                // happens amids the pending invocation.
	                trailingCall = true;
	            }
	            else {
	                leadingCall = true;
	                trailingCall = false;
	                setTimeout(timeoutCallback, delay);
	            }
	            lastCallTime = timeStamp;
	        }
	        return proxy;
	    }
	
	    // Minimum delay before invoking the update of observers.
	    var REFRESH_DELAY = 20;
	    // A list of substrings of CSS properties used to find transition events that
	    // might affect dimensions of observed elements.
	    var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	    // Check if MutationObserver is available.
	    var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	    /**
	     * Singleton controller class which handles updates of ResizeObserver instances.
	     */
	    var ResizeObserverController = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserverController.
	         *
	         * @private
	         */
	        function ResizeObserverController() {
	            /**
	             * Indicates whether DOM listeners have been added.
	             *
	             * @private {boolean}
	             */
	            this.connected_ = false;
	            /**
	             * Tells that controller has subscribed for Mutation Events.
	             *
	             * @private {boolean}
	             */
	            this.mutationEventsAdded_ = false;
	            /**
	             * Keeps reference to the instance of MutationObserver.
	             *
	             * @private {MutationObserver}
	             */
	            this.mutationsObserver_ = null;
	            /**
	             * A list of connected observers.
	             *
	             * @private {Array<ResizeObserverSPI>}
	             */
	            this.observers_ = [];
	            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	            this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	        }
	        /**
	         * Adds observer to observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be added.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.addObserver = function (observer) {
	            if (!~this.observers_.indexOf(observer)) {
	                this.observers_.push(observer);
	            }
	            // Add listeners if they haven't been added yet.
	            if (!this.connected_) {
	                this.connect_();
	            }
	        };
	        /**
	         * Removes observer from observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be removed.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.removeObserver = function (observer) {
	            var observers = this.observers_;
	            var index = observers.indexOf(observer);
	            // Remove observer if it's present in registry.
	            if (~index) {
	                observers.splice(index, 1);
	            }
	            // Remove listeners if controller has no connected observers.
	            if (!observers.length && this.connected_) {
	                this.disconnect_();
	            }
	        };
	        /**
	         * Invokes the update of observers. It will continue running updates insofar
	         * it detects changes.
	         *
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.refresh = function () {
	            var changesDetected = this.updateObservers_();
	            // Continue running updates if changes have been detected as there might
	            // be future ones caused by CSS transitions.
	            if (changesDetected) {
	                this.refresh();
	            }
	        };
	        /**
	         * Updates every observer from observers list and notifies them of queued
	         * entries.
	         *
	         * @private
	         * @returns {boolean} Returns "true" if any observer has detected changes in
	         *      dimensions of it's elements.
	         */
	        ResizeObserverController.prototype.updateObservers_ = function () {
	            // Collect observers that have active observations.
	            var activeObservers = this.observers_.filter(function (observer) {
	                return observer.gatherActive(), observer.hasActive();
	            });
	            // Deliver notifications in a separate cycle in order to avoid any
	            // collisions between observers, e.g. when multiple instances of
	            // ResizeObserver are tracking the same element and the callback of one
	            // of them changes content dimensions of the observed target. Sometimes
	            // this may result in notifications being blocked for the rest of observers.
	            activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	            return activeObservers.length > 0;
	        };
	        /**
	         * Initializes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.connect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already added.
	            if (!isBrowser || this.connected_) {
	                return;
	            }
	            // Subscription to the "Transitionend" event is used as a workaround for
	            // delayed transitions. This way it's possible to capture at least the
	            // final state of an element.
	            document.addEventListener('transitionend', this.onTransitionEnd_);
	            window.addEventListener('resize', this.refresh);
	            if (mutationObserverSupported) {
	                this.mutationsObserver_ = new MutationObserver(this.refresh);
	                this.mutationsObserver_.observe(document, {
	                    attributes: true,
	                    childList: true,
	                    characterData: true,
	                    subtree: true
	                });
	            }
	            else {
	                document.addEventListener('DOMSubtreeModified', this.refresh);
	                this.mutationEventsAdded_ = true;
	            }
	            this.connected_ = true;
	        };
	        /**
	         * Removes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.disconnect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already removed.
	            if (!isBrowser || !this.connected_) {
	                return;
	            }
	            document.removeEventListener('transitionend', this.onTransitionEnd_);
	            window.removeEventListener('resize', this.refresh);
	            if (this.mutationsObserver_) {
	                this.mutationsObserver_.disconnect();
	            }
	            if (this.mutationEventsAdded_) {
	                document.removeEventListener('DOMSubtreeModified', this.refresh);
	            }
	            this.mutationsObserver_ = null;
	            this.mutationEventsAdded_ = false;
	            this.connected_ = false;
	        };
	        /**
	         * "Transitionend" event handler.
	         *
	         * @private
	         * @param {TransitionEvent} event
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
	            var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
	            // Detect whether transition may affect dimensions of an element.
	            var isReflowProperty = transitionKeys.some(function (key) {
	                return !!~propertyName.indexOf(key);
	            });
	            if (isReflowProperty) {
	                this.refresh();
	            }
	        };
	        /**
	         * Returns instance of the ResizeObserverController.
	         *
	         * @returns {ResizeObserverController}
	         */
	        ResizeObserverController.getInstance = function () {
	            if (!this.instance_) {
	                this.instance_ = new ResizeObserverController();
	            }
	            return this.instance_;
	        };
	        /**
	         * Holds reference to the controller's instance.
	         *
	         * @private {ResizeObserverController}
	         */
	        ResizeObserverController.instance_ = null;
	        return ResizeObserverController;
	    }());
	
	    /**
	     * Defines non-writable/enumerable properties of the provided target object.
	     *
	     * @param {Object} target - Object for which to define properties.
	     * @param {Object} props - Properties to be defined.
	     * @returns {Object} Target object.
	     */
	    var defineConfigurable = (function (target, props) {
	        for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	            var key = _a[_i];
	            Object.defineProperty(target, key, {
	                value: props[key],
	                enumerable: false,
	                writable: false,
	                configurable: true
	            });
	        }
	        return target;
	    });
	
	    /**
	     * Returns the global object associated with provided element.
	     *
	     * @param {Object} target
	     * @returns {Object}
	     */
	    var getWindowOf = (function (target) {
	        // Assume that the element is an instance of Node, which means that it
	        // has the "ownerDocument" property from which we can retrieve a
	        // corresponding global object.
	        var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	        // Return the local global object if it's not possible extract one from
	        // provided element.
	        return ownerGlobal || global$1;
	    });
	
	    // Placeholder of an empty content rectangle.
	    var emptyRect = createRectInit(0, 0, 0, 0);
	    /**
	     * Converts provided string to a number.
	     *
	     * @param {number|string} value
	     * @returns {number}
	     */
	    function toFloat(value) {
	        return parseFloat(value) || 0;
	    }
	    /**
	     * Extracts borders size from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @param {...string} positions - Borders positions (top, right, ...)
	     * @returns {number}
	     */
	    function getBordersSize(styles) {
	        var positions = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            positions[_i - 1] = arguments[_i];
	        }
	        return positions.reduce(function (size, position) {
	            var value = styles['border-' + position + '-width'];
	            return size + toFloat(value);
	        }, 0);
	    }
	    /**
	     * Extracts paddings sizes from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @returns {Object} Paddings box.
	     */
	    function getPaddings(styles) {
	        var positions = ['top', 'right', 'bottom', 'left'];
	        var paddings = {};
	        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
	            var position = positions_1[_i];
	            var value = styles['padding-' + position];
	            paddings[position] = toFloat(value);
	        }
	        return paddings;
	    }
	    /**
	     * Calculates content rectangle of provided SVG element.
	     *
	     * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	     *      to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getSVGContentRect(target) {
	        var bbox = target.getBBox();
	        return createRectInit(0, 0, bbox.width, bbox.height);
	    }
	    /**
	     * Calculates content rectangle of provided HTMLElement.
	     *
	     * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	     * @returns {DOMRectInit}
	     */
	    function getHTMLElementContentRect(target) {
	        // Client width & height properties can't be
	        // used exclusively as they provide rounded values.
	        var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
	        // By this condition we can catch all non-replaced inline, hidden and
	        // detached elements. Though elements with width & height properties less
	        // than 0.5 will be discarded as well.
	        //
	        // Without it we would need to implement separate methods for each of
	        // those cases and it's not possible to perform a precise and performance
	        // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	        // gives wrong results for elements with width & height less than 0.5.
	        if (!clientWidth && !clientHeight) {
	            return emptyRect;
	        }
	        var styles = getWindowOf(target).getComputedStyle(target);
	        var paddings = getPaddings(styles);
	        var horizPad = paddings.left + paddings.right;
	        var vertPad = paddings.top + paddings.bottom;
	        // Computed styles of width & height are being used because they are the
	        // only dimensions available to JS that contain non-rounded values. It could
	        // be possible to utilize the getBoundingClientRect if only it's data wasn't
	        // affected by CSS transformations let alone paddings, borders and scroll bars.
	        var width = toFloat(styles.width), height = toFloat(styles.height);
	        // Width & height include paddings and borders when the 'border-box' box
	        // model is applied (except for IE).
	        if (styles.boxSizing === 'border-box') {
	            // Following conditions are required to handle Internet Explorer which
	            // doesn't include paddings and borders to computed CSS dimensions.
	            //
	            // We can say that if CSS dimensions + paddings are equal to the "client"
	            // properties then it's either IE, and thus we don't need to subtract
	            // anything, or an element merely doesn't have paddings/borders styles.
	            if (Math.round(width + horizPad) !== clientWidth) {
	                width -= getBordersSize(styles, 'left', 'right') + horizPad;
	            }
	            if (Math.round(height + vertPad) !== clientHeight) {
	                height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	            }
	        }
	        // Following steps can't be applied to the document's root element as its
	        // client[Width/Height] properties represent viewport area of the window.
	        // Besides, it's as well not necessary as the <html> itself neither has
	        // rendered scroll bars nor it can be clipped.
	        if (!isDocumentElement(target)) {
	            // In some browsers (only in Firefox, actually) CSS width & height
	            // include scroll bars size which can be removed at this step as scroll
	            // bars are the only difference between rounded dimensions + paddings
	            // and "client" properties, though that is not always true in Chrome.
	            var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	            var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	            // Chrome has a rather weird rounding of "client" properties.
	            // E.g. for an element with content width of 314.2px it sometimes gives
	            // the client width of 315px and for the width of 314.7px it may give
	            // 314px. And it doesn't happen all the time. So just ignore this delta
	            // as a non-relevant.
	            if (Math.abs(vertScrollbar) !== 1) {
	                width -= vertScrollbar;
	            }
	            if (Math.abs(horizScrollbar) !== 1) {
	                height -= horizScrollbar;
	            }
	        }
	        return createRectInit(paddings.left, paddings.top, width, height);
	    }
	    /**
	     * Checks whether provided element is an instance of the SVGGraphicsElement.
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    var isSVGGraphicsElement = (function () {
	        // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	        // interface.
	        if (typeof SVGGraphicsElement !== 'undefined') {
	            return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	        }
	        // If it's so, then check that element is at least an instance of the
	        // SVGElement and that it has the "getBBox" method.
	        // eslint-disable-next-line no-extra-parens
	        return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
	            typeof target.getBBox === 'function'); };
	    })();
	    /**
	     * Checks whether provided element is a document element (<html>).
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    function isDocumentElement(target) {
	        return target === getWindowOf(target).document.documentElement;
	    }
	    /**
	     * Calculates an appropriate content rectangle for provided html or svg element.
	     *
	     * @param {Element} target - Element content rectangle of which needs to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getContentRect(target) {
	        if (!isBrowser) {
	            return emptyRect;
	        }
	        if (isSVGGraphicsElement(target)) {
	            return getSVGContentRect(target);
	        }
	        return getHTMLElementContentRect(target);
	    }
	    /**
	     * Creates rectangle with an interface of the DOMRectReadOnly.
	     * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	     *
	     * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	     * @returns {DOMRectReadOnly}
	     */
	    function createReadOnlyRect(_a) {
	        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	        // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	        var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	        var rect = Object.create(Constr.prototype);
	        // Rectangle's properties are not writable and non-enumerable.
	        defineConfigurable(rect, {
	            x: x, y: y, width: width, height: height,
	            top: y,
	            right: x + width,
	            bottom: height + y,
	            left: x
	        });
	        return rect;
	    }
	    /**
	     * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	     * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	     *
	     * @param {number} x - X coordinate.
	     * @param {number} y - Y coordinate.
	     * @param {number} width - Rectangle's width.
	     * @param {number} height - Rectangle's height.
	     * @returns {DOMRectInit}
	     */
	    function createRectInit(x, y, width, height) {
	        return { x: x, y: y, width: width, height: height };
	    }
	
	    /**
	     * Class that is responsible for computations of the content rectangle of
	     * provided DOM element and for keeping track of it's changes.
	     */
	    var ResizeObservation = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObservation.
	         *
	         * @param {Element} target - Element to be observed.
	         */
	        function ResizeObservation(target) {
	            /**
	             * Broadcasted width of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastWidth = 0;
	            /**
	             * Broadcasted height of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastHeight = 0;
	            /**
	             * Reference to the last observed content rectangle.
	             *
	             * @private {DOMRectInit}
	             */
	            this.contentRect_ = createRectInit(0, 0, 0, 0);
	            this.target = target;
	        }
	        /**
	         * Updates content rectangle and tells whether it's width or height properties
	         * have changed since the last broadcast.
	         *
	         * @returns {boolean}
	         */
	        ResizeObservation.prototype.isActive = function () {
	            var rect = getContentRect(this.target);
	            this.contentRect_ = rect;
	            return (rect.width !== this.broadcastWidth ||
	                rect.height !== this.broadcastHeight);
	        };
	        /**
	         * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	         * from the corresponding properties of the last observed content rectangle.
	         *
	         * @returns {DOMRectInit} Last observed content rectangle.
	         */
	        ResizeObservation.prototype.broadcastRect = function () {
	            var rect = this.contentRect_;
	            this.broadcastWidth = rect.width;
	            this.broadcastHeight = rect.height;
	            return rect;
	        };
	        return ResizeObservation;
	    }());
	
	    var ResizeObserverEntry = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObserverEntry.
	         *
	         * @param {Element} target - Element that is being observed.
	         * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
	         */
	        function ResizeObserverEntry(target, rectInit) {
	            var contentRect = createReadOnlyRect(rectInit);
	            // According to the specification following properties are not writable
	            // and are also not enumerable in the native implementation.
	            //
	            // Property accessors are not being used as they'd require to define a
	            // private WeakMap storage which may cause memory leaks in browsers that
	            // don't support this type of collections.
	            defineConfigurable(this, { target: target, contentRect: contentRect });
	        }
	        return ResizeObserverEntry;
	    }());
	
	    var ResizeObserverSPI = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback function that is invoked
	         *      when one of the observed elements changes it's content dimensions.
	         * @param {ResizeObserverController} controller - Controller instance which
	         *      is responsible for the updates of observer.
	         * @param {ResizeObserver} callbackCtx - Reference to the public
	         *      ResizeObserver instance which will be passed to callback function.
	         */
	        function ResizeObserverSPI(callback, controller, callbackCtx) {
	            /**
	             * Collection of resize observations that have detected changes in dimensions
	             * of elements.
	             *
	             * @private {Array<ResizeObservation>}
	             */
	            this.activeObservations_ = [];
	            /**
	             * Registry of the ResizeObservation instances.
	             *
	             * @private {Map<Element, ResizeObservation>}
	             */
	            this.observations_ = new MapShim();
	            if (typeof callback !== 'function') {
	                throw new TypeError('The callback provided as parameter 1 is not a function.');
	            }
	            this.callback_ = callback;
	            this.controller_ = controller;
	            this.callbackCtx_ = callbackCtx;
	        }
	        /**
	         * Starts observing provided element.
	         *
	         * @param {Element} target - Element to be observed.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.observe = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is already being observed.
	            if (observations.has(target)) {
	                return;
	            }
	            observations.set(target, new ResizeObservation(target));
	            this.controller_.addObserver(this);
	            // Force the update of observations.
	            this.controller_.refresh();
	        };
	        /**
	         * Stops observing provided element.
	         *
	         * @param {Element} target - Element to stop observing.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.unobserve = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is not being observed.
	            if (!observations.has(target)) {
	                return;
	            }
	            observations.delete(target);
	            if (!observations.size) {
	                this.controller_.removeObserver(this);
	            }
	        };
	        /**
	         * Stops observing all elements.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.disconnect = function () {
	            this.clearActive();
	            this.observations_.clear();
	            this.controller_.removeObserver(this);
	        };
	        /**
	         * Collects observation instances the associated element of which has changed
	         * it's content rectangle.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.gatherActive = function () {
	            var _this = this;
	            this.clearActive();
	            this.observations_.forEach(function (observation) {
	                if (observation.isActive()) {
	                    _this.activeObservations_.push(observation);
	                }
	            });
	        };
	        /**
	         * Invokes initial callback function with a list of ResizeObserverEntry
	         * instances collected from active resize observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.broadcastActive = function () {
	            // Do nothing if observer doesn't have active observations.
	            if (!this.hasActive()) {
	                return;
	            }
	            var ctx = this.callbackCtx_;
	            // Create ResizeObserverEntry instance for every active observation.
	            var entries = this.activeObservations_.map(function (observation) {
	                return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	            });
	            this.callback_.call(ctx, entries, ctx);
	            this.clearActive();
	        };
	        /**
	         * Clears the collection of active observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.clearActive = function () {
	            this.activeObservations_.splice(0);
	        };
	        /**
	         * Tells whether observer has active observations.
	         *
	         * @returns {boolean}
	         */
	        ResizeObserverSPI.prototype.hasActive = function () {
	            return this.activeObservations_.length > 0;
	        };
	        return ResizeObserverSPI;
	    }());
	
	    // Registry of internal observers. If WeakMap is not available use current shim
	    // for the Map collection as it has all required methods and because WeakMap
	    // can't be fully polyfilled anyway.
	    var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	    /**
	     * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	     * exposing only those methods and properties that are defined in the spec.
	     */
	    var ResizeObserver = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback that is invoked when
	         *      dimensions of the observed elements change.
	         */
	        function ResizeObserver(callback) {
	            if (!(this instanceof ResizeObserver)) {
	                throw new TypeError('Cannot call a class as a function.');
	            }
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            var controller = ResizeObserverController.getInstance();
	            var observer = new ResizeObserverSPI(callback, controller, this);
	            observers.set(this, observer);
	        }
	        return ResizeObserver;
	    }());
	    // Expose public methods of ResizeObserver.
	    [
	        'observe',
	        'unobserve',
	        'disconnect'
	    ].forEach(function (method) {
	        ResizeObserver.prototype[method] = function () {
	            var _a;
	            return (_a = observers.get(this))[method].apply(_a, arguments);
	        };
	    });
	
	    var index = (function () {
	        // Export existing implementation if available.
	        if (typeof global$1.ResizeObserver !== 'undefined') {
	            return global$1.ResizeObserver;
	        }
	        return ResizeObserver;
	    })();
	
	    return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 60:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 61:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 73:
/***/ (function(module, exports) {

	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(7);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(10);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(9);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSlick = __webpack_require__(67);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ArrowL = __webpack_require__(698);
	
	var _ArrowL2 = _interopRequireDefault(_ArrowL);
	
	var _ArrowR = __webpack_require__(699);
	
	var _ArrowR2 = _interopRequireDefault(_ArrowR);
	
	__webpack_require__(61);
	
	__webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Link = _styledComponents2.default.a.withConfig({
	  displayName: 'Slider__Link',
	  componentId: 'sc-1kcnxtp-0'
	})(['width:85vw;margin-top:50px;opacity:', ';transition:all 0.3s;', ';', ';&:hover{opacity:', ';', ';}'], function (_ref) {
	  var center = _ref.center;
	  return center ? 1 : 0.5;
	}, function (_ref2) {
	  var darken = _ref2.darken;
	  return darken && 'opacity: 1;';
	}, function (_ref3) {
	  var darken = _ref3.darken;
	  return darken && 'filter: brightness(50%);';
	}, function (_ref4) {
	  var darken = _ref4.darken;
	  return darken ? 0.5 : 1;
	}, function (_ref5) {
	  var center = _ref5.center,
	      isRight = _ref5.isRight;
	  return center ? null : 'cursor: ' + (isRight ? 'e-resize' : 'w-resize');
	});
	
	var Wrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'Slider__Wrapper',
	  componentId: 'sc-1kcnxtp-1'
	})(['', ';', ';'], function (_ref6) {
	  var darken = _ref6.darken;
	  return darken && '\n    & .slick-active a {\n      filter: brightness(100%);\n    }\n  ';
	}, function (_ref7) {
	  var arrows = _ref7.arrows;
	  return arrows && '\n    & .slick-prev:before,\n    & .slick-next:before {\n      display: none !important;\n    }\n\n    & .slick-prev {\n      left: 140px;\n      top: calc(50% + 25px);\n\n      @media (max-width: 900px) {\n        left: 15px;\n      }\n    }\n\n    & .slick-next {\n      right: 140px;\n      top: calc(50% + 25px);\n\n      @media (max-width: 900px) {\n        right: 15px;\n      }\n    }\n  ';
	});
	
	var Image = _styledComponents2.default.img.withConfig({
	  displayName: 'Slider__Image',
	  componentId: 'sc-1kcnxtp-2'
	})(['object-fit:contain;width:100%;height:auto;']);
	
	var Arrow = _styledComponents2.default.div.withConfig({
	  displayName: 'Slider__Arrow',
	  componentId: 'sc-1kcnxtp-3'
	})(['background-color:#f2f7fa !important;width:40px !important;height:40px !important;border-radius:100% !important;display:flex !important;align-items:center !important;justify-content:center !important;box-shadow:0 0 6px 0 rgba(0,0,0,0.1) !important;z-index:10;']);
	
	var CustomSlider = function (_Component) {
	  (0, _inherits3.default)(CustomSlider, _Component);
	
	  function CustomSlider() {
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, CustomSlider);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      slideIndex: 0
	    }, _this.navigation = function (isRight) {
	      isRight ? _this.slider.slickNext() : _this.slider.slickPrev();
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  CustomSlider.prototype.render = function render() {
	    var _this2 = this;
	
	    var slideIndex = this.state.slideIndex;
	    var _props = this.props,
	        imgSrc = _props.imgSrc,
	        imgSrcSet = _props.imgSrcSet,
	        centerPadding = _props.centerPadding,
	        arrows = _props.arrows,
	        darken = _props.darken,
	        urls = _props.urls;
	
	    var settings = (0, _extends3.default)({}, arrows && {
	      prevArrow: _react2.default.createElement(
	        Arrow,
	        null,
	        _react2.default.createElement('img', { alt: '', src: _ArrowL2.default })
	      ),
	      nextArrow: _react2.default.createElement(
	        Arrow,
	        null,
	        _react2.default.createElement('img', { alt: '', src: _ArrowR2.default })
	      )
	    }, {
	      centerMode: true,
	      dots: false,
	      speed: 1000,
	      slidesToShow: 1,
	      slidesToScroll: 1,
	      centerPadding: centerPadding || '20%',
	      draggable: false,
	      beforeChange: function beforeChange(current, next) {
	        return _this2.setState({ slideIndex: next });
	      }
	    });
	    var count = imgSrc ? imgSrc.length - 1 : 0;
	    var root = this;
	    var src = imgSrcSet || imgSrc;
	    return _react2.default.createElement(
	      Wrapper,
	      { arrows: arrows, darken: darken },
	      _react2.default.createElement(
	        _reactSlick2.default,
	        (0, _extends3.default)({ ref: function ref(slider) {
	            return _this2.slider = slider;
	          } }, settings),
	        src && src.map(function (s, i) {
	          var center = slideIndex === i;
	          var isRight = slideIndex < i;
	
	          if (slideIndex === count && i === 0) {
	            isRight = true;
	          } else if (slideIndex === 0 && i === count) {
	            isRight = false;
	          } else {
	            isRight = slideIndex < i;
	          }
	          var onClick = function onClick(e) {
	            if (!center) {
	              root.navigation(isRight);
	              e.preventDefault();
	            }
	          };
	          return _react2.default.createElement(
	            Link,
	            {
	              key: i,
	              onClick: onClick,
	              isRight: isRight,
	              center: center,
	              darken: darken,
	              href: urls[i],
	              target: '_blank',
	              rel: 'noreferrer'
	            },
	            _react2.default.createElement(Image, typeof s === 'string' ? { src: s } : {
	              srcSet: imgSrcSet[i]._1x + ' 1x, ' + imgSrcSet[i]._2x + ' 2x,' + imgSrcSet[i]._3x + ' 3x'
	            })
	          );
	        })
	      )
	    );
	  };
	
	  return CustomSlider;
	}(_react.Component);
	
	exports.default = CustomSlider;
	module.exports = exports['default'];

/***/ }),

/***/ 329:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Slider = __webpack_require__(315);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Container = _styledComponents2.default.div.withConfig({
	  displayName: 'ProductFeature__Container',
	  componentId: 'sc-7xjubj-0'
	})(['display:flex;flex-direction:column;justify-content:space-between;align-items:center;margin:0px auto;@media (max-width:900px){margin-bottom:0;}']);
	
	var TitleWrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'ProductFeature__TitleWrapper',
	  componentId: 'sc-7xjubj-1'
	})(['text-align:center;margin-top:', ';max-width:', ';@media (max-width:900px){margin-top:', ';}'], function (_ref) {
	  var titleMarginTop = _ref.titleMarginTop;
	  return titleMarginTop || '15px';
	}, function (_ref2) {
	  var titleWidth = _ref2.titleWidth;
	  return titleWidth || '55%';
	}, function (_ref3) {
	  var titleMarginTopMob = _ref3.titleMarginTopMob;
	  return titleMarginTopMob || '15px';
	});
	
	var TextWrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'ProductFeature__TextWrapper',
	  componentId: 'sc-7xjubj-2'
	})(['text-align:center;margin-top:', ';max-width:90%;@media (min-width:901px){max-width:', ';margin-top:20px;}'], function (_ref4) {
	  var textMarginTopMob = _ref4.textMarginTopMob;
	  return textMarginTopMob || '20px';
	}, function (_ref5) {
	  var textWidth = _ref5.textWidth;
	  return textWidth || '55%';
	});
	
	var Text = _styledComponents2.default.p.withConfig({
	  displayName: 'ProductFeature__Text',
	  componentId: 'sc-7xjubj-3'
	})(['@media (max-width:900px){font-size:12px;line-height:17px;}']);
	
	var Title = _styledComponents2.default.h4.withConfig({
	  displayName: 'ProductFeature__Title',
	  componentId: 'sc-7xjubj-4'
	})(['font-weight:700;font-size:20px;line-height:1.5;@media (max-width:900px){font-size:15px;line-height:1.4;}']);
	
	var ImageWrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'ProductFeature__ImageWrapper',
	  componentId: 'sc-7xjubj-5'
	})(['text-align:center;']);
	
	var SlickWrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'ProductFeature__SlickWrapper',
	  componentId: 'sc-7xjubj-6'
	})(['overflow:hidden;', ';'], function (_ref6) {
	  var fullWidth = _ref6.fullWidth;
	  return fullWidth ? 'width: 100vw;' : '';
	});
	
	var Image = _styledComponents2.default.img.withConfig({
	  displayName: 'ProductFeature__Image',
	  componentId: 'sc-7xjubj-7'
	})(['width:', ';margin-top:50px;@media (max-width:900px){margin-top:20px;width:100%;}'], function (_ref7) {
	  var carousel = _ref7.carousel;
	  return carousel ? '100vw' : '80vw';
	});
	
	exports.default = function (_ref8) {
	  var fullWidth = _ref8.fullWidth,
	      imgSrc = _ref8.imgSrc,
	      imgSrcSet = _ref8.imgSrcSet,
	      title = _ref8.title,
	      text = _ref8.text,
	      carousel = _ref8.carousel,
	      centerPadding = _ref8.centerPadding,
	      arrows = _ref8.arrows,
	      darken = _ref8.darken,
	      titleWidth = _ref8.titleWidth,
	      titleMarginTop = _ref8.titleMarginTop,
	      titleMarginTopMob = _ref8.titleMarginTopMob,
	      textMarginTopMob = _ref8.textMarginTopMob,
	      textWidth = _ref8.textWidth,
	      urls = _ref8.urls;
	  return _react2.default.createElement(
	    SlickWrapper,
	    { fullWidth: fullWidth },
	    carousel && _react2.default.createElement(_Slider2.default, {
	      urls: urls,
	      imgSrc: imgSrc,
	      imgSrcSet: imgSrcSet,
	      centerPadding: centerPadding,
	      arrows: arrows,
	      darken: darken
	    }),
	    _react2.default.createElement(
	      Container,
	      null,
	      !carousel && _react2.default.createElement(
	        ImageWrapper,
	        null,
	        _react2.default.createElement(Image, { carousel: carousel, src: imgSrc })
	      ),
	      title && _react2.default.createElement(
	        TitleWrapper,
	        {
	          titleWidth: titleWidth,
	          titleMarginTop: titleMarginTop,
	          titleMarginTopMob: titleMarginTopMob
	        },
	        _react2.default.createElement(
	          Title,
	          null,
	          title
	        )
	      ),
	      text && _react2.default.createElement(
	        TextWrapper,
	        { textWidth: textWidth, textMarginTopMob: textMarginTopMob },
	        _react2.default.createElement(
	          Text,
	          null,
	          text
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styles = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var containerMarginTop = function containerMarginTop(noExtraMarginTop, marginTopMob) {
	  if (noExtraMarginTop && marginTopMob) return marginTopMob + 'px';else if (noExtraMarginTop) return '40px;';
	  return '80px;';
	}; /* eslint-disable react/prop-types */
	
	
	var Container = _styledComponents2.default.div.withConfig({
	  displayName: 'RegistrationAndTicketing__Container',
	  componentId: 'sc-197afi2-0'
	})(['display:flex;justify-content:space-between;align-items:center;', ';', ';@media (max-width:900px){flex-direction:column;margin-top:', ';}'], function (props) {
	  return props.marginLeft ? 'margin: 30px 10px 0 ' + props.marginLeft + ';' : 'margin: 30px 10px 0 10px;';
	}, function (props) {
	  return props.marginTop && 'margin-top:' + props.marginTop + 'px;';
	}, function (_ref) {
	  var noExtraMarginTop = _ref.noExtraMarginTop,
	      marginTopMob = _ref.marginTopMob;
	  return containerMarginTop(noExtraMarginTop, marginTopMob);
	});
	
	var spacing = function spacing(imgOnLeft, contentLeftPadding) {
	  if (imgOnLeft && contentLeftPadding) return 'padding-left: ' + contentLeftPadding + 'px';else if (imgOnLeft) return 'padding-left: 80px;';
	  return 'padding-right: 80px;';
	};
	
	var TitleWrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'RegistrationAndTicketing__TitleWrapper',
	  componentId: 'sc-197afi2-1'
	})(['display:flex;width:100%;flex-direction:column;text-align:left;order:1;margin-top:', ';@media (min-width:901px){margin-top:0;width:50%;', ';}'], function (props) {
	  return props.contentMarginTop ? props.contentMarginTop + 'px' : '25px';
	}, function (_ref2) {
	  var imgOnLeft = _ref2.imgOnLeft,
	      contentLeftPadding = _ref2.contentLeftPadding;
	  return spacing(imgOnLeft, contentLeftPadding);
	});
	
	var Title = _styledComponents2.default.h3.withConfig({
	  displayName: 'RegistrationAndTicketing__Title',
	  componentId: 'sc-197afi2-2'
	})(['font-size:20px;font-weight:700;margin-bottom:20px;line-height:1.5;@media (max-width:900px){font-size:15px;line-height:1.2;text-align:center;margin-bottom:', ';', ';}'], function (props) {
	  return props.headingMarginBottom && props.headingMarginBottom + 'px';
	}, function (_ref3) {
	  var titleSpacing = _ref3.titleSpacing;
	  return titleSpacing && 'padding-left: ' + titleSpacing + 'px; padding-right: ' + titleSpacing + 'px;';
	});
	
	var Description = _styledComponents2.default.p.withConfig({
	  displayName: 'RegistrationAndTicketing__Description',
	  componentId: 'sc-197afi2-3'
	})(['font-size:15px;width:', ';', ';@media (max-width:900px){text-align:center;font-size:', ';width:', ';', ';}'], function (_ref4) {
	  var descriptionWidth = _ref4.descriptionWidth;
	  return descriptionWidth || '93%';
	}, function (props) {
	  return props.descriptionLineHeight ? 'line-height: ' + props.descriptionLineHeight + ';' : 'line-height: 1.4;';
	}, function (props) {
	  return props.descriptionFontSize ? props.descriptionFontSize + 'px' : '13px';
	}, function (_ref5) {
	  var descriptionWidthMob = _ref5.descriptionWidthMob;
	  return descriptionWidthMob || '98%';
	}, function (props) {
	  return props.descriptionInMid ? 'margin: 0 auto;' : '';
	});
	
	var DescriptionWrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'RegistrationAndTicketing__DescriptionWrapper',
	  componentId: 'sc-197afi2-4'
	})(['@media (max-width:900px){padding:0 5px;}']);
	
	var ImageWrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'RegistrationAndTicketing__ImageWrapper',
	  componentId: 'sc-197afi2-5'
	})(['flex:1;order:', ';', ';', ';', ';', ';@media (max-width:900px){order:0;padding:0;}'], function (props) {
	  return props.imgOnLeft ? 0 : 1;
	}, function (props) {
	  return props.ImgSpacingOnRight ? 'padding-left: ' + props.ImgSpacingOnRight : '';
	}, function (props) {
	  return props.wideImg && 'margin-right:-3%;';
	}, function (props) {
	  return props.alignLeft && 'text-align: left;';
	}, function (props) {
	  return props.alignRight && 'text-align: right;';
	});
	
	var Image = _styledComponents2.default.img.withConfig({
	  displayName: 'RegistrationAndTicketing__Image',
	  componentId: 'sc-197afi2-6'
	})(['max-width:100%;']);
	
	var Step = _styledComponents2.default.p.withConfig({
	  displayName: 'RegistrationAndTicketing__Step',
	  componentId: 'sc-197afi2-7'
	})(['color:', ';font-size:100px;font-weight:700;line-height:1.15;@media (max-width:900px){display:none;}'], _styles.colors.lightBlueGray);
	
	var ChildContainer = _styledComponents2.default.div.withConfig({
	  displayName: 'RegistrationAndTicketing__ChildContainer',
	  componentId: 'sc-197afi2-8'
	})(['']);
	
	exports.default = function (_ref6) {
	  var title = _ref6.title,
	      description = _ref6.description,
	      imgSrc = _ref6.imgSrc,
	      imgOnLeft = _ref6.imgOnLeft,
	      noExtraMarginTop = _ref6.noExtraMarginTop,
	      step = _ref6.step,
	      srcSet = _ref6.srcSet,
	      ImgSpacingOnRight = _ref6.ImgSpacingOnRight,
	      marginLeft = _ref6.marginLeft,
	      alignLeft = _ref6.alignLeft,
	      alignRight = _ref6.alignRight,
	      descriptionLineHeight = _ref6.descriptionLineHeight,
	      wideImg = _ref6.wideImg,
	      descriptionInMid = _ref6.descriptionInMid,
	      marginTop = _ref6.marginTop,
	      contentLeftPadding = _ref6.contentLeftPadding,
	      marginTopMob = _ref6.marginTopMob,
	      contentMarginTop = _ref6.contentMarginTop,
	      headingMarginBottom = _ref6.headingMarginBottom,
	      descriptionFontSize = _ref6.descriptionFontSize,
	      titleSpacing = _ref6.titleSpacing,
	      descriptionWidth = _ref6.descriptionWidth,
	      descriptionWidthMob = _ref6.descriptionWidthMob,
	      button = _ref6.button,
	      children = _ref6.children;
	  return _react2.default.createElement(
	    Container,
	    {
	      noExtraMarginTop: noExtraMarginTop,
	      marginLeft: marginLeft,
	      marginTop: marginTop,
	      marginTopMob: marginTopMob
	    },
	    _react2.default.createElement(
	      TitleWrapper,
	      {
	        imgOnLeft: imgOnLeft,
	        contentLeftPadding: contentLeftPadding,
	        contentMarginTop: contentMarginTop
	      },
	      step && _react2.default.createElement(
	        Step,
	        null,
	        step
	      ),
	      _react2.default.createElement(
	        Title,
	        {
	          headingMarginBottom: headingMarginBottom,
	          titleSpacing: titleSpacing
	        },
	        title
	      ),
	      _react2.default.createElement(
	        DescriptionWrapper,
	        null,
	        _react2.default.createElement(
	          Description,
	          {
	            descriptionLineHeight: descriptionLineHeight,
	            descriptionInMid: descriptionInMid,
	            descriptionFontSize: descriptionFontSize,
	            descriptionWidth: descriptionWidth,
	            descriptionWidthMob: descriptionWidthMob
	          },
	          description
	        ),
	        children && _react2.default.createElement(
	          ChildContainer,
	          null,
	          children
	        )
	      ),
	      button
	    ),
	    _react2.default.createElement(
	      ImageWrapper,
	      {
	        imgOnLeft: imgOnLeft,
	        ImgSpacingOnRight: ImgSpacingOnRight,
	        alignLeft: alignLeft,
	        alignRight: alignRight,
	        wideImg: wideImg
	      },
	      _react2.default.createElement(Image, { src: imgSrc, srcSet: srcSet })
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/apple_store.2928664f.svg";

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/drag_and_drop_email.089d802d.png";

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/drag_and_drop_email@2x.daffff3d.png";

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/drag_and_drop_email@3x.74cdd110.png";

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/drag_and_drop_form.cde46b34.png";

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/drag_and_drop_form@2x.724b0f07.png";

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/drag_and_drop_form@3x.ecfc4dca.png";

/***/ }),

/***/ 221:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/google_store@2x.494c736b.jpg";

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/google_store@3x.3ed10a7f.jpg";

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mbl_application.a27f3924.png";

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mbl_application@2x.bcea68c6.png";

/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mbl_application@3x.fb79b470.png";

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/statistics_img.6afc4a26.png";

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/statistics_img@2x.541081d4.png";

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/statistics_img@3x.844ba2f9.png";

/***/ }),

/***/ 683:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Advantage01@1x.5817b189.png";

/***/ }),

/***/ 684:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Advantage01@2x.56fc4cea.png";

/***/ }),

/***/ 685:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Advantage01@3x.311e3b25.png";

/***/ }),

/***/ 686:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Advantage02@1x.d5579d29.png";

/***/ }),

/***/ 687:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Advantage02@2x.d90cbb2d.png";

/***/ }),

/***/ 688:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Advantage02@3x.4ba81639.png";

/***/ }),

/***/ 689:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Advantage03@1x.d42d3e7b.png";

/***/ }),

/***/ 690:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Advantage03@2x.8e4787fd.png";

/***/ }),

/***/ 691:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Advantage03@3x.d3d8c152.png";

/***/ }),

/***/ 692:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Advantage04@1x.86eccdbb.png";

/***/ }),

/***/ 693:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Advantage04@2x.78d9143d.png";

/***/ }),

/***/ 694:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Advantage04@3x.4a62ea08.png";

/***/ }),

/***/ 695:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Advantage05@1x.8edb401d.png";

/***/ }),

/***/ 696:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Advantage05@2x.1672d74d.png";

/***/ }),

/***/ 697:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Advantage05@3x.c4a65610.png";

/***/ }),

/***/ 698:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0iYSIgZD0iTTE1LjY2IDYuNzRhMSAxIDAgMCAwLTEuMzQ0LTEuNDhMNyAxMS44OTlsNy4zMTYgNi42MzhhMSAxIDAgMSAwIDEuMzQ0LTEuNDgxbC01LjY4NC01LjE1N0wxNS42NiA2Ljc0eiIvPgogICAgICAgIDxwYXRoIGlkPSJjIiBkPSJNNyA1aDguOTg4djEzLjc5Nkg3eiIvPgogICAgPC9kZWZzPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8bWFzayBpZD0iYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2EiLz4KICAgICAgICA8L21hc2s+CiAgICAgICAgPHVzZSBmaWxsPSIjN0Q5MDlBIiB4bGluazpocmVmPSIjYSIvPgogICAgICAgIDxwYXRoIGZpbGw9IiM3RDkwOUEiIGQ9Ik0wIDBoMjR2MjRIMHoiIG1hc2s9InVybCgjYikiLz4KICAgIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ 699:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0iYSIgZD0iTTguMzI4IDYuNzRhMSAxIDAgMCAxIDEuMzQ0LTEuNDhsNy4zMTYgNi42MzgtNy4zMTYgNi42MzlhMSAxIDAgMSAxLTEuMzQ0LTEuNDgxbDUuNjg0LTUuMTU4LTUuNjg0LTUuMTU3eiIvPgogICAgPC9kZWZzPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8bWFzayBpZD0iYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2EiLz4KICAgICAgICA8L21hc2s+CiAgICAgICAgPHVzZSBmaWxsPSIjN0Q5MDlBIiB4bGluazpocmVmPSIjYSIvPgogICAgICAgIDxwYXRoIGZpbGw9IiM3RDkwOUEiIGQ9Ik0wIDBoMjR2MjRIMHoiIG1hc2s9InVybCgjYikiLz4KICAgIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ 700:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 701:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/HeroPicture.e26d314e.svg";

/***/ }),

/***/ 702:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Slide01@1x.5c17d288.png";

/***/ }),

/***/ 703:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Slide01@2x.d2995308.png";

/***/ }),

/***/ 704:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Slide01@3x.3ab058be.png";

/***/ }),

/***/ 705:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Slide02@1x.03dc8847.png";

/***/ }),

/***/ 706:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Slide02@2x.1fd987be.png";

/***/ }),

/***/ 707:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Slide02@3x.36e3d1e8.png";

/***/ }),

/***/ 708:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Slide03@1x.c08e7451.png";

/***/ }),

/***/ 709:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Slide03@2x.f188174f.png";

/***/ }),

/***/ 710:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Slide03@3x.f941b30f.png";

/***/ }),

/***/ 346:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(19);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _FeatureList = __webpack_require__(130);
	
	var _FeatureList2 = _interopRequireDefault(_FeatureList);
	
	var _GetStarted = __webpack_require__(45);
	
	var _GetStarted2 = _interopRequireDefault(_GetStarted);
	
	var _header = __webpack_require__(20);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _PaymentMethods = __webpack_require__(131);
	
	var _PaymentMethods2 = _interopRequireDefault(_PaymentMethods);
	
	var _ProductFeature = __webpack_require__(329);
	
	var _ProductFeature2 = _interopRequireDefault(_ProductFeature);
	
	var _ProductIntroduce = __webpack_require__(30);
	
	var _ProductIntroduce2 = _interopRequireDefault(_ProductIntroduce);
	
	var _RegistrationAndTicketing = __webpack_require__(37);
	
	var _RegistrationAndTicketing2 = _interopRequireDefault(_RegistrationAndTicketing);
	
	var _SectionWrapper = __webpack_require__(31);
	
	var _SectionWrapper2 = _interopRequireDefault(_SectionWrapper);
	
	var _Advantage011x = __webpack_require__(683);
	
	var _Advantage011x2 = _interopRequireDefault(_Advantage011x);
	
	var _Advantage012x = __webpack_require__(684);
	
	var _Advantage012x2 = _interopRequireDefault(_Advantage012x);
	
	var _Advantage013x = __webpack_require__(685);
	
	var _Advantage013x2 = _interopRequireDefault(_Advantage013x);
	
	var _Advantage021x = __webpack_require__(686);
	
	var _Advantage021x2 = _interopRequireDefault(_Advantage021x);
	
	var _Advantage022x = __webpack_require__(687);
	
	var _Advantage022x2 = _interopRequireDefault(_Advantage022x);
	
	var _Advantage023x = __webpack_require__(688);
	
	var _Advantage023x2 = _interopRequireDefault(_Advantage023x);
	
	var _Advantage031x = __webpack_require__(689);
	
	var _Advantage031x2 = _interopRequireDefault(_Advantage031x);
	
	var _Advantage032x = __webpack_require__(690);
	
	var _Advantage032x2 = _interopRequireDefault(_Advantage032x);
	
	var _Advantage033x = __webpack_require__(691);
	
	var _Advantage033x2 = _interopRequireDefault(_Advantage033x);
	
	var _Advantage041x = __webpack_require__(692);
	
	var _Advantage041x2 = _interopRequireDefault(_Advantage041x);
	
	var _Advantage042x = __webpack_require__(693);
	
	var _Advantage042x2 = _interopRequireDefault(_Advantage042x);
	
	var _Advantage043x = __webpack_require__(694);
	
	var _Advantage043x2 = _interopRequireDefault(_Advantage043x);
	
	var _Advantage051x = __webpack_require__(695);
	
	var _Advantage051x2 = _interopRequireDefault(_Advantage051x);
	
	var _Advantage052x = __webpack_require__(696);
	
	var _Advantage052x2 = _interopRequireDefault(_Advantage052x);
	
	var _Advantage053x = __webpack_require__(697);
	
	var _Advantage053x2 = _interopRequireDefault(_Advantage053x);
	
	var _EventPagePicture = __webpack_require__(700);
	
	var _EventPagePicture2 = _interopRequireDefault(_EventPagePicture);
	
	var _Feature = __webpack_require__(150);
	
	var _Feature2 = _interopRequireDefault(_Feature);
	
	var _Feature3 = __webpack_require__(151);
	
	var _Feature4 = _interopRequireDefault(_Feature3);
	
	var _HeroPicture = __webpack_require__(701);
	
	var _HeroPicture2 = _interopRequireDefault(_HeroPicture);
	
	var _Slide011x = __webpack_require__(702);
	
	var _Slide011x2 = _interopRequireDefault(_Slide011x);
	
	var _Slide012x = __webpack_require__(703);
	
	var _Slide012x2 = _interopRequireDefault(_Slide012x);
	
	var _Slide013x = __webpack_require__(704);
	
	var _Slide013x2 = _interopRequireDefault(_Slide013x);
	
	var _Slide021x = __webpack_require__(705);
	
	var _Slide021x2 = _interopRequireDefault(_Slide021x);
	
	var _Slide022x = __webpack_require__(706);
	
	var _Slide022x2 = _interopRequireDefault(_Slide022x);
	
	var _Slide023x = __webpack_require__(707);
	
	var _Slide023x2 = _interopRequireDefault(_Slide023x);
	
	var _Slide031x = __webpack_require__(708);
	
	var _Slide031x2 = _interopRequireDefault(_Slide031x);
	
	var _Slide032x = __webpack_require__(709);
	
	var _Slide032x2 = _interopRequireDefault(_Slide032x);
	
	var _Slide033x = __webpack_require__(710);
	
	var _Slide033x2 = _interopRequireDefault(_Slide033x);
	
	var _drag_and_drop_email = __webpack_require__(215);
	
	var _drag_and_drop_email2 = _interopRequireDefault(_drag_and_drop_email);
	
	var _drag_and_drop_email2x = __webpack_require__(216);
	
	var _drag_and_drop_email2x2 = _interopRequireDefault(_drag_and_drop_email2x);
	
	var _drag_and_drop_email3x = __webpack_require__(217);
	
	var _drag_and_drop_email3x2 = _interopRequireDefault(_drag_and_drop_email3x);
	
	var _statistics_img = __webpack_require__(227);
	
	var _statistics_img2 = _interopRequireDefault(_statistics_img);
	
	var _statistics_img2x = __webpack_require__(228);
	
	var _statistics_img2x2 = _interopRequireDefault(_statistics_img2x);
	
	var _statistics_img3x = __webpack_require__(229);
	
	var _statistics_img3x2 = _interopRequireDefault(_statistics_img3x);
	
	var _drag_and_drop_form = __webpack_require__(218);
	
	var _drag_and_drop_form2 = _interopRequireDefault(_drag_and_drop_form);
	
	var _drag_and_drop_form2x = __webpack_require__(219);
	
	var _drag_and_drop_form2x2 = _interopRequireDefault(_drag_and_drop_form2x);
	
	var _drag_and_drop_form3x = __webpack_require__(220);
	
	var _drag_and_drop_form3x2 = _interopRequireDefault(_drag_and_drop_form3x);
	
	var _mbl_application = __webpack_require__(224);
	
	var _mbl_application2 = _interopRequireDefault(_mbl_application);
	
	var _mbl_application2x = __webpack_require__(225);
	
	var _mbl_application2x2 = _interopRequireDefault(_mbl_application2x);
	
	var _mbl_application3x = __webpack_require__(226);
	
	var _mbl_application3x2 = _interopRequireDefault(_mbl_application3x);
	
	var _apple_store = __webpack_require__(214);
	
	var _apple_store2 = _interopRequireDefault(_apple_store);
	
	var _google_store = __webpack_require__(221);
	
	var _google_store2 = _interopRequireDefault(_google_store);
	
	var _google_store2x = __webpack_require__(222);
	
	var _google_store2x2 = _interopRequireDefault(_google_store2x);
	
	var _google_store3x = __webpack_require__(223);
	
	var _google_store3x2 = _interopRequireDefault(_google_store3x);
	
	var _i18n = __webpack_require__(4);
	
	var _commons = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// old engagement stuff
	var t = (0, _i18n.translate)('pages/products/events');
	
	var _process$env = ({"NODE_ENV":"production","PUBLIC_DIR":"/opt/build/repo/public","GATSBY_TELEMETRY_DISABLED":"1","GATSBY_MANAGER_URL":"https://manager.juven.co","GATSBY_FRONTEND_URL":"https://juven.co","GATSBY_GA_KEY":"UA-111109988-1","GATSBY_JUVEN_ENQUIRY_URL":"https://juven.co/api/enquiries"}),
	    GATSBY_MANAGER_URL = _process$env.GATSBY_MANAGER_URL,
	    GATSBY_FRONTEND_URL = _process$env.GATSBY_FRONTEND_URL;
	
	
	var Wrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'events__Wrapper',
	  componentId: 'axhkzn-0'
	})(['overflow-x:hidden;']);
	
	var ProductDescription = _styledComponents2.default.div.withConfig({
	  displayName: 'events__ProductDescription',
	  componentId: 'axhkzn-1'
	})(['font-size:12px;line-height:1.6;width:', ';margin:10px auto 30px;text-align:center;@media (min-width:901px){width:', ';font-size:15px;margin:20px auto 30px;}&::after{width:100%;height:100%;content:', ';@media (max-width:900px){content:', ';}}'], function (_ref) {
	  var widthMob = _ref.widthMob;
	  return widthMob || '50%';
	}, function (_ref2) {
	  var width = _ref2.width;
	  return width || '75%';
	}, function (_ref3) {
	  var description = _ref3.description;
	  return '"' + description + '"';
	}, function (_ref4) {
	  var description = _ref4.description,
	      descriptionMob = _ref4.descriptionMob;
	  return '"' + (descriptionMob || description) + '"';
	});
	
	var SectionHeading = _styledComponents2.default.h2.withConfig({
	  displayName: 'events__SectionHeading',
	  componentId: 'axhkzn-2'
	})(['text-align:center;font-size:25px;line-height:1.2;font-weight:bold;margin:0 auto;width:100%;padding-bottom:', ';text-transform:none;@media (max-width:900px){font-size:', ';width:80%;padding-bottom:', ';line-height:1.5;}'], function (props) {
	  return props.paddingBottom ? props.paddingBottom + 'px' : '20px';
	}, function (props) {
	  return props.fontSizeMob ? props.fontSizeMob + 'px' : '25px';
	}, function (props) {
	  return props.paddingBottomMob ? props.paddingBottomMob + 'px' : '20px';
	});
	
	var Button = _styledComponents2.default.a.withConfig({
	  displayName: 'events__Button',
	  componentId: 'axhkzn-3'
	})(['display:block;padding:12px 30px;font-size:15px;font-weight:bold;line-height:1.2;background-color:', ';color:', ';border-radius:1000px;cursor:pointer;transition:all 0.2s;width:fit-content;', ';&:hover{color:', ';background-color:', ';}@media (max-width:900px){', ';}', ';', ';'], function (_ref5) {
	  var inverted = _ref5.inverted;
	  return inverted ? '#00a7ff' : '#fff';
	}, function (_ref6) {
	  var inverted = _ref6.inverted;
	  return inverted ? '#fff' : '#00a7ff';
	}, function (_ref7) {
	  var margin = _ref7.margin;
	  return margin && 'margin: ' + margin + ';';
	}, function (_ref8) {
	  var inverted = _ref8.inverted;
	  return inverted ? '#00a7ff' : '#fff';
	}, function (_ref9) {
	  var inverted = _ref9.inverted;
	  return inverted ? '#fff' : '#00a7ff';
	}, function (_ref10) {
	  var marginMob = _ref10.marginMob;
	  return marginMob && 'margin: ' + marginMob + ';';
	}, function (_ref11) {
	  var hideOnSmallScreen = _ref11.hideOnSmallScreen;
	  return hideOnSmallScreen && '@media (max-width: 900px) { display: none; }';
	}, function (_ref12) {
	  var hideOnLargeScreen = _ref12.hideOnLargeScreen;
	  return hideOnLargeScreen && '@media (min-width: 901px) { display: none; }';
	});
	
	var HeroWrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'events__HeroWrapper',
	  componentId: 'axhkzn-4'
	})(['background-image:linear-gradient(to top,#ffffff,#16c89f);text-align:center;display:flex;justify-content:center;align-items:center;padding-top:85px;flex-direction:column;@media (max-width:900px){padding-bottom:70px;padding-top:105px;}']);
	
	var HeroIcon = _styledComponents2.default.img.withConfig({
	  displayName: 'events__HeroIcon',
	  componentId: 'axhkzn-5'
	})(['margin-bottom:10px;width:60px;height:60px;']);
	
	var HeroHeading = _styledComponents2.default.h1.withConfig({
	  displayName: 'events__HeroHeading',
	  componentId: 'axhkzn-6'
	})(['color:#fff;font-size:45px;line-height:1.25;text-align:center;font-weight:bold;margin-bottom:10px;width:925px;text-transform:none;@media (max-width:900px){font-size:25px;line-height:1.2;width:90%;}']);
	
	var HeroSubHeading = _styledComponents2.default.h2.withConfig({
	  displayName: 'events__HeroSubHeading',
	  componentId: 'axhkzn-7'
	})(['color:#fff;font-size:25px;line-height:1.4;text-align:center;font-weight:normal;margin-bottom:42px;width:720px;text-transform:none;@media (max-width:900px){font-size:15px;line-height:1.4;width:unset;}']);
	
	var HeroPicture = _styledComponents2.default.img.withConfig({
	  displayName: 'events__HeroPicture',
	  componentId: 'axhkzn-8'
	})(['display:block;margin-top:70px;@media (max-width:900px){width:150%;margin-top:60px;}']);
	
	var EventPagePicture = _styledComponents2.default.img.withConfig({
	  displayName: 'events__EventPagePicture',
	  componentId: 'axhkzn-9'
	})(['width:80px;height:80px;margin:0 auto 30px;display:block;@media (max-width:900px){width:60px;height:60px;}']);
	
	var Oval = _styledComponents2.default.div.withConfig({
	  displayName: 'events__Oval',
	  componentId: 'axhkzn-10'
	})(['width:', ';height:', ';background:', ';position:absolute;border-radius:100%;', ';', ';', ';', ';@media (max-width:900px){display:none;}'], function (_ref13) {
	  var width = _ref13.width;
	  return width;
	}, function (_ref14) {
	  var height = _ref14.height;
	  return height;
	}, function (_ref15) {
	  var color = _ref15.color;
	  return color;
	}, function (_ref16) {
	  var top = _ref16.top;
	  return top && 'top: ' + top;
	}, function (_ref17) {
	  var bottom = _ref17.bottom;
	  return bottom && 'bottom: ' + bottom;
	}, function (_ref18) {
	  var left = _ref18.left;
	  return left && 'left: ' + left;
	}, function (_ref19) {
	  var right = _ref19.right;
	  return right && 'right: ' + right;
	});
	
	var SliderContainer = _styledComponents2.default.div.withConfig({
	  displayName: 'events__SliderContainer',
	  componentId: 'axhkzn-11'
	})(['transform:translateX(calc((100% - 100vw) / 2));margin-bottom:20px;', ';', ';'], function (_ref20) {
	  var hideOnSmallScreen = _ref20.hideOnSmallScreen;
	  return hideOnSmallScreen && '@media (max-width: 900px) { display: none; }';
	}, function (_ref21) {
	  var hideOnLargeScreen = _ref21.hideOnLargeScreen;
	  return hideOnLargeScreen && '@media (min-width: 901px) { display: none; }';
	});
	
	// old engagement stuff
	var MblAppIconContainer = _styledComponents2.default.div.withConfig({
	  displayName: 'events__MblAppIconContainer',
	  componentId: 'axhkzn-12'
	})(['display:flex;padding-top:30px;@media (max-width:900px){justify-content:center;}']);
	
	var MblAppIconWrapper = _styledComponents2.default.a.withConfig({
	  displayName: 'events__MblAppIconWrapper',
	  componentId: 'axhkzn-13'
	})(['padding-right:20px;']);
	
	var Image = _styledComponents2.default.img.withConfig({
	  displayName: 'events__Image',
	  componentId: 'axhkzn-14'
	})(['max-width:100%;']);
	
	var AppImage = (0, _styledComponents2.default)(Image).withConfig({
	  displayName: 'events__AppImage',
	  componentId: 'axhkzn-15'
	})(['max-height:46px;height:46px;']);
	
	var FeatureListData = [{
	  picture: _Feature2.default,
	  heading: 'Membership',
	  description: 'Customize your membership system, turn your contacts into members, and reward members with privileges and benefits.',
	  url: '/products/membership'
	}];
	
	exports.default = function () {
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      { title: t('Event Creation and Ticketing | Juven') },
	      _react2.default.createElement('meta', {
	        name: 'description',
	        content: t('Looking a better way to create events? Juven helps event organizations run recurring events, multi-session ticketing, and customizable event pages. Start for free!')
	      })
	    ),
	    _react2.default.createElement(_header2.default, {
	      desktopNotFixed: true,
	      mobileHidden: false,
	      navigationBarNotFixed: true,
	      showLanguage: true
	    }),
	    _react2.default.createElement(
	      HeroWrapper,
	      null,
	      _react2.default.createElement(HeroIcon, { alt: '', src: _Feature4.default }),
	      _react2.default.createElement(
	        HeroHeading,
	        null,
	        t('Powerful, intelligent and feature-rich tools for event management')
	      ),
	      _react2.default.createElement(
	        HeroSubHeading,
	        null,
	        t('Save time, increase productivity and resolve ticketing issues')
	      ),
	      _react2.default.createElement(_commons.LinkButton, {
	        href: GATSBY_MANAGER_URL + '/signup',
	        text: t('Try it today'),
	        id: 'events_top_banner_cta'
	      }),
	      _react2.default.createElement(HeroPicture, {
	        alt: t('Powerful, intelligent and feature-rich tools for event management'),
	        src: _HeroPicture2.default
	      })
	    ),
	    _react2.default.createElement(
	      _SectionWrapper2.default,
	      {
	        paddingTop: '120',
	        paddingBottom: '90',
	        customPaddingBottom: '90',
	        paddingBottomMob: '90',
	        paddingTopMob: '30'
	      },
	      _react2.default.createElement(_ProductIntroduce2.default, {
	        title: t('Events are simple and easy to create'),
	        fontSizeWeb: '25',
	        fontSizeMob: '20'
	      }),
	      _react2.default.createElement(_RegistrationAndTicketing2.default, {
	        title: '' + t('Highly flexible ticketing setting'),
	        descriptionLineHeight: '1.6',
	        descriptionInMid: true,
	        marginTop: '90',
	        marginTopMob: '30',
	        alignRight: true,
	        noExtraMarginTop: true,
	        contentMarginTop: '10',
	        headingMarginBottom: '10',
	        descriptionFontSize: '12',
	        imgSrc: _Advantage011x2.default,
	        srcSet: _Advantage011x2.default + ' 1x, ' + _Advantage012x2.default + ' 2x, ' + _Advantage013x2.default + ' 3x',
	        description: t('Unique for event organizations, you can set exclusive event ticket types and dates. You can also set different promotional codes and ticketing packages.')
	      }),
	      _react2.default.createElement(_RegistrationAndTicketing2.default, {
	        title: '' + t('Multi-sessions ticketing'),
	        descriptionLineHeight: '1.6',
	        descriptionInMid: true,
	        marginTopMob: '90',
	        alignLeft: true,
	        imgOnLeft: true,
	        noExtraMarginTop: true,
	        contentMarginTop: '10',
	        headingMarginBottom: '10',
	        descriptionFontSize: '12',
	        imgSrc: _Advantage021x2.default,
	        srcSet: _Advantage021x2.default + ' 1x, ' + _Advantage022x2.default + ' 2x, ' + _Advantage023x2.default + ' 3x',
	        description: t('Automate your team’s repetitive work. You can set events to repeat daily, weekly or monthly, over a period in a single keystroke.')
	      }),
	      _react2.default.createElement(_RegistrationAndTicketing2.default, {
	        title: '' + t('Mobile responsive event ticketing page'),
	        descriptionLineHeight: '1.6',
	        descriptionInMid: true,
	        marginTop: '40',
	        marginTopMob: '90',
	        alignRight: true,
	        noExtraMarginTop: true,
	        contentMarginTop: '10',
	        headingMarginBottom: '10',
	        descriptionFontSize: '12',
	        imgSrc: _Advantage031x2.default,
	        srcSet: _Advantage031x2.default + ' 1x, ' + _Advantage032x2.default + ' 2x, ' + _Advantage033x2.default + ' 3x',
	        description: t('Our ticketing page can be accessed online at any time from any device in any browser. Our manager app and user app to support everything you need in event organization and ticketing management.')
	      }),
	      _react2.default.createElement(_RegistrationAndTicketing2.default, {
	        title: '' + t('Review & Approval'),
	        descriptionLineHeight: '1.6',
	        descriptionInMid: true,
	        marginTop: '60',
	        marginTopMob: '90',
	        alignLeft: true,
	        imgOnLeft: true,
	        noExtraMarginTop: true,
	        contentMarginTop: '10',
	        headingMarginBottom: '10',
	        descriptionFontSize: '12',
	        imgSrc: _Advantage041x2.default,
	        srcSet: _Advantage041x2.default + ' 1x, ' + _Advantage042x2.default + ' 2x, ' + _Advantage043x2.default + ' 3x',
	        description: t('You can validate and approve potential guests who RSVP to your events before sending tickets to them. Keep track on your attendee list and deliver consistent responses.')
	      }),
	      _react2.default.createElement(_RegistrationAndTicketing2.default, {
	        title: '' + t('Customized badges for guests'),
	        descriptionLineHeight: '1.6',
	        descriptionInMid: true,
	        marginTop: '60',
	        marginTopMob: '90',
	        alignRight: true,
	        noExtraMarginTop: true,
	        contentMarginTop: '10',
	        headingMarginBottom: '10',
	        descriptionFontSize: '12',
	        imgSrc: _Advantage051x2.default,
	        descriptionWidth: '420px',
	        descriptionWidthMob: '100%',
	        srcSet: _Advantage051x2.default + ' 1x, ' + _Advantage052x2.default + ' 2x, ' + _Advantage053x2.default + ' 3x',
	        description: t('Automatically create ready-to-print customized badges for guests that can serve as tickets and identification for any event. Know more about your guests effortlessly with our template RSVP and registration forms.')
	      })
	    ),
	    _react2.default.createElement(
	      _SectionWrapper2.default,
	      {
	        paddingTop: '73',
	        paddingBottomMob: '90',
	        customPaddingBottom: '0'
	      },
	      _react2.default.createElement(
	        SectionHeading,
	        { fontSizeMob: '20' },
	        t('Engage with your community before and after the event')
	      ),
	      _react2.default.createElement(_RegistrationAndTicketing2.default, {
	        noExtraMarginTop: true,
	        description: t('Enhance your pre and post event engagement by reviewing and analyzing real-time reports. Track your events in real time to get meaningful insights through detailed analytics. All this to organize better events and long-term membership engagement.'),
	        ImgSpacingOnRight: '5%',
	        descriptionLineHeight: '1.6',
	        marginLeft: '20px',
	        descriptionInMid: true,
	        marginTopMob: '30',
	        contentMarginTop: '10',
	        headingMarginBottom: '10',
	        descriptionFontSize: '12',
	        imgSrc: _statistics_img2.default,
	        srcSet: _statistics_img3x2.default + ' 3x, ' + _statistics_img2x2.default + ' 2x, ' + _statistics_img2.default + ' 1x',
	        title: t('Get the bigger picture')
	      }),
	      _react2.default.createElement(_RegistrationAndTicketing2.default, {
	        description: t('Collate all your contacts into one email marketing system to drive engagement. Create your own email templates with different functions and fields, send them off right away.'),
	        descriptionLineHeight: '1.6',
	        alignLeft: true,
	        imgOnLeft: true,
	        descriptionInMid: true,
	        marginTop: '90',
	        marginTopMob: '90',
	        noExtraMarginTop: true,
	        contentMarginTop: '10',
	        headingMarginBottom: '10',
	        descriptionFontSize: '12',
	        imgSrc: _drag_and_drop_email2.default,
	        srcSet: _drag_and_drop_email3x2.default + ' 3x, ' + _drag_and_drop_email2x2.default + ' 2x, ' + _drag_and_drop_email2.default + ' 1x',
	        title: t('Reduce repetitive email tasks')
	      }),
	      _react2.default.createElement(_RegistrationAndTicketing2.default, {
	        description: t('Faster responses and reaction on critical issues, always engage with your members to gather information and get feedbacks. Our easy-to-use form builder tools help you create any kind of surveys and forms.'),
	        ImgSpacingOnRight: '5%',
	        descriptionLineHeight: '1.6',
	        marginLeft: '20px',
	        descriptionInMid: true,
	        marginTop: '90',
	        marginTopMob: '90',
	        noExtraMarginTop: true,
	        contentMarginTop: '10',
	        headingMarginBottom: '10',
	        descriptionFontSize: '12',
	        imgSrc: _drag_and_drop_form2.default,
	        srcSet: _drag_and_drop_form3x2.default + ' 3x, ' + _drag_and_drop_form2x2.default + ' 2x, ' + _drag_and_drop_form2.default + ' 1x',
	        title: t('Build positive relationship')
	      }),
	      _react2.default.createElement(
	        _RegistrationAndTicketing2.default,
	        {
	          description: t('See everything you need in anytime, anywhere. Simplify your team\'s event management tasks, shorten guests\' waiting time, support membership service, improve the overall satisfaction in event organization and engagement.'),
	          descriptionLineHeight: '1.6',
	          alignLeft: true,
	          imgOnLeft: true,
	          descriptionInMid: true,
	          marginTop: '90',
	          marginTopMob: '90',
	          noExtraMarginTop: true,
	          contentMarginTop: '30',
	          headingMarginBottom: '10',
	          descriptionFontSize: '12',
	          imgSrc: _mbl_application2.default,
	          srcSet: _mbl_application3x2.default + ' 3x, ' + _mbl_application2x2.default + ' 2x, ' + _mbl_application2.default + ' 1x',
	          title: t('On-the-go with Juven Manager App')
	        },
	        _react2.default.createElement(
	          MblAppIconContainer,
	          null,
	          _react2.default.createElement(
	            MblAppIconWrapper,
	            {
	              href: 'https://itunes.apple.com/us/app/juven-manager-app/id1438847545',
	              target: '_blank',
	              rel: 'noopener noreferrer',
	              id: 'engagement_mobile_app_ios'
	            },
	            _react2.default.createElement(AppImage, { src: _apple_store2.default })
	          ),
	          _react2.default.createElement(
	            MblAppIconWrapper,
	            {
	              href: 'https://play.google.com/store/apps/details?id=com.juven.juvenmanagerapp',
	              target: '_blank',
	              rel: 'noopener noreferrer',
	              id: 'engagement_mobile_app_android'
	            },
	            _react2.default.createElement(AppImage, {
	              src: _google_store2.default,
	              srcSet: _google_store3x2.default + ' 3x, ' + _google_store2x2.default + ' 2x, ' + _google_store2.default + ' 1x'
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _SectionWrapper2.default,
	      {
	        backgroundColor: true,
	        paddingTop: '120',
	        paddingBottomMob: '90',
	        paddingTopMob: '60'
	      },
	      _react2.default.createElement(Oval, {
	        color: 'linear-gradient(to bottom, #9de6ff, #64c9ff)',
	        width: '360px',
	        height: '360px',
	        right: '-140px',
	        top: '-180px'
	      }),
	      _react2.default.createElement(EventPagePicture, { alt: 'Express Event Page', src: _EventPagePicture2.default }),
	      _react2.default.createElement(_ProductIntroduce2.default, {
	        title: t('Making beautiful event pages is easy!'),
	        fontSizeWeb: '25',
	        fontSizeMob: '20'
	      }),
	      _react2.default.createElement(_RegistrationAndTicketing2.default, {
	        button: _react2.default.createElement(
	          Button,
	          {
	            margin: '30px 0 0 0',
	            marginMob: '30px auto 60px',
	            inverted: true,
	            href: GATSBY_MANAGER_URL + '/signup',
	            id: 'events_create_events_now'
	          },
	          t('Create event now')
	        ),
	        title: '' + t('Express Event Page'),
	        descriptionLineHeight: '1.6',
	        descriptionInMid: true,
	        marginTop: '90',
	        marginTopMob: '60',
	        alignRight: true,
	        noExtraMarginTop: true,
	        contentMarginTop: '10',
	        headingMarginBottom: '10',
	        descriptionFontSize: '12',
	        imgSrc: _Advantage031x2.default,
	        srcSet: _Advantage031x2.default + ' 1x, ' + _Advantage032x2.default + ' 2x, ' + _Advantage033x2.default + ' 3x',
	        description: t('Start with our express event page to create your event. Easy and straightforward to navigate, allowing everyone to see what’s on, what tickets are available, and who is the event organizers.')
	      }),
	      _react2.default.createElement(
	        SliderContainer,
	        { hideOnSmallScreen: true },
	        _react2.default.createElement(_ProductFeature2.default, {
	          title: t('Tailor-made unique catalog page'),
	          textWidth: '60%',
	          text: t('Your imagination is the limit. Our designers can help create stunning bespoke event pages, all while powered by Juven\'s robust technologies to suites all kinds of event organizations. These are available on a project basis.'),
	          urls: ['https://juven.co/detour2018', 'https://juven.co/thistownneeds', 'https://juven.co/themillshk'],
	          imgSrcSet: [{ _1x: _Slide011x2.default, _2x: _Slide012x2.default, _3x: _Slide013x2.default }, { _1x: _Slide021x2.default, _2x: _Slide022x2.default, _3x: _Slide023x2.default }, { _1x: _Slide031x2.default, _2x: _Slide032x2.default, _3x: _Slide033x2.default }],
	          carousel: true,
	          fullWidth: true,
	          arrows: true,
	          darken: true
	        })
	      ),
	      _react2.default.createElement(
	        SliderContainer,
	        { hideOnLargeScreen: true },
	        _react2.default.createElement(_ProductFeature2.default, {
	          titleMarginTop: '25px',
	          titleMarginTopMob: '20px',
	          titleWidth: '100%',
	          title: t('Tailor-made unique catalog page'),
	          textMarginTopMob: '10px',
	          text: t('Your imagination is the limit. Our designers can help create stunning bespoke event pages, all while powered by Juven\'s robust technologies to suites all kinds of event organizations. These are available on a project basis.'),
	          urls: ['https://juven.co/detour2018', 'https://juven.co/thistownneeds', 'https://juven.co/themillshk'],
	          imgSrcSet: [{ _1x: _Slide011x2.default, _2x: _Slide012x2.default, _3x: _Slide013x2.default }, { _1x: _Slide021x2.default, _2x: _Slide022x2.default, _3x: _Slide023x2.default }, { _1x: _Slide031x2.default, _2x: _Slide032x2.default, _3x: _Slide033x2.default }],
	          carousel: true,
	          fullWidth: true,
	          centerPadding: '10px',
	          arrows: true,
	          darken: true
	        })
	      ),
	      _react2.default.createElement(
	        Button,
	        {
	          margin: '30px auto 0',
	          inverted: true,
	          href: 'https://juven.co/contact',
	          target: '_blank',
	          rel: 'noreferrer',
	          id: 'events_contact_sales'
	        },
	        t('Contact sales')
	      )
	    ),
	    _react2.default.createElement(
	      _SectionWrapper2.default,
	      { paddingTop: '120', paddingBottomMob: '90', paddingTopMob: '90' },
	      _react2.default.createElement(Oval, {
	        color: 'linear-gradient(to bottom, #9de6ff, #64c9ff)',
	        width: '360px',
	        height: '360px',
	        left: '-140px',
	        top: '-90px'
	      }),
	      _react2.default.createElement(_ProductIntroduce2.default, {
	        title: t('Unlimited ticket sales for a flat fee'),
	        titleMob: t('Free, paid or recurring'),
	        fontSizeWeb: '25',
	        fontSizeMob: '20'
	      }),
	      _react2.default.createElement(ProductDescription, {
	        width: '645px',
	        widthMob: '90%',
	        description: t('With the Juven Community Builder plan, there\'s no Juven transaction cost on ticketing or membership fees.'),
	        descriptionMob: t('No matter how you charge your members, Juven can handle it. Our pricing is affordable and easy to understand.')
	      }),
	      _react2.default.createElement(_PaymentMethods2.default, {
	        image: _Feature4.default,
	        title: t('Events Manager'),
	        pricing: { percent: 0 },
	        source: 'events'
	      })
	    ),
	    _react2.default.createElement(_GetStarted2.default, {
	      heading: t('Creating events is easier than you think!'),
	      buttonText: t('Try it today'),
	      url: GATSBY_MANAGER_URL + '/signup',
	      source: 'events'
	    }),
	    _react2.default.createElement(
	      _SectionWrapper2.default,
	      {
	        backgroundColor: true,
	        paddingTop: '120',
	        paddingTopMob: '90',
	        paddingBottomMob: '60'
	      },
	      _react2.default.createElement(
	        SectionHeading,
	        { fontSizeMob: '20', paddingBottom: '60', paddingBottomMob: '30' },
	        t('Explore other features in Juven')
	      ),
	      _react2.default.createElement(_FeatureList2.default, { list: FeatureListData })
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-products-events-jsx-88f1a85184d65710d53b.js